{
  "createHub": {
    "title": "Créer",
    "open": "Créer",
    "close": "Fermer",
    "actionsHeader": "Démarrer",
    "newWorkout": {
      "title": "Nouvel entraînement",
      "sub": "Commencer un entraînement vierge maintenant"
    },
    "repeatWorkout": {
      "title": "Répéter un entraînement",
      "sub": "Enregistrer depuis un entraînement passé"
    },
    "planProgram": {
      "title": "Planifier un programme",
      "sub": "Créer un programme sur plusieurs semaines"
    },
    "planWorkout": {
      "title": "Planifier un entraînement",
      "sub": "Préparer une seule séance pour plus tard"
    }
  },
  "library": {
    "header": "Parcourir",
    "tabPrograms": "Programmes",
    "tabWorkouts": "Entraînements",
    "tabPersonal": "À moi",
    "tabCoach": "Coach",
    "tabFavorites": "Favoris",
    "favoriteA11y": "Favori",
    "errFavorite": "Impossible de mettre à jour les favoris.",
    "emptyFavoritesTitle": "Pas encore de favoris",
    "emptyFavoritesSub": "Ajoute une étoile à un programme ou un entraînement pour le retrouver ici.",
    "sectionOfficial": "Par JackedLogs",
    "sectionPersonal": "À moi",
    "clone": "Cloner",
    "copySuffix": "(copie)",
    "following": "Activation…",
    "searchPlaceholder": "Rechercher par nom…",
    "filters": "Filtres",
    "clearFilters": "Effacer",
    "axisLevel": "Niveau",
    "axisPerWeek": "Séances / semaine",
    "noResultsTitle": "Aucun résultat",
    "noResultsSub": "Modifie la recherche ou les filtres.",
    "loading": "Chargement de la bibliothèque…",
    "errLoad": "Impossible de charger la bibliothèque.",
    "errClone": "Le clonage a échoué. Réessaie.",
    "errDelete": "La suppression a échoué. Réessaie.",
    "errFollow": "Impossible de suivre le programme.",
    "errStatus": "Impossible de mettre à jour le programme.",
    "emptyTitle": "Rien ici pour l'instant",
    "emptySub": "Les programmes et les entraînements que tu crées ou clones apparaîtront ici.",
    "coachSoonTitle": "De ton coach",
    "coachSoonSub": "Les programmes et les entraînements assignés par ton coach apparaîtront ici."
  },
  "common": {
    "lastDataAt": "Dernière donnée {{at}}",
    "languageA11y": "Langue",
    "infoA11y": "Info",
    "unsavedChanges": {
      "title": "Abandonner les modifications ?",
      "body": "Les modifications non enregistrées seront perdues.",
      "keepEditing": "Continuer la modification",
      "discard": "Abandonner"
    }
  },
  "bodymap": {
    "viewBack": "Dos",
    "viewFront": "Face",
    "workedTitle": "Muscles sollicités",
    "workedPrimary": "primaires",
    "workedSecondary": "secondaires",
    "heatmapTitle": "Muscles les plus travaillés",
    "heatmapLow": "peu",
    "heatmapHigh": "beaucoup",
    "window7d": "7 jours",
    "window30d": "30 jours",
    "painTitle": "Carte de douleur",
    "painHelp": "Tape un muscle pour le marquer : rouge (éviter les charges lourdes), jaune (prudence). Sauvegardé automatiquement.",
    "painRed": "éviter",
    "painYellow": "prudence",
    "painClearAll": "Tout effacer",
    "painSaving": "Sauvegarde…",
    "painSaveError": "Échec de la sauvegarde. Vérifie la connexion.",
    "painRiskA11y": "Risque de douleur : {{severity}}",
    "painSeverity": {
      "red": "élevé",
      "yellow": "modéré",
      "green": "faible"
    }
  },
  "plates": {
    "title": "Répartition des disques",
    "openHint": "Afficher la répartition",
    "close": "Fermer",
    "targetLabel": "Cible",
    "barLabel": "Barre",
    "barAria": "Poids de la barre",
    "barNone": "Sans barre",
    "perSide": "Par côté",
    "perSidePair": "{{count}} × {{plate}}",
    "barOnly": "Juste la barre — aucun disque nécessaire.",
    "belowBar": "La cible est plus légère que la barre.",
    "invalidInput": "Saisis d'abord un poids valide.",
    "remainder": "+{{weight}} sous la cible avec l'inventaire actuel.",
    "fallbackPill": "maximum possible",
    "inventoryLegend": "Paires disponibles",
    "inventoryHint": "Paires de chaque disque disponibles maintenant. Mets 0 si la salle ne l'a pas ou que le rack est vide. Sauvegardé entre les sessions.",
    "pairsAria": "Paires de {{plate}} disponibles",
    "loadedEnd": "Extrémité chargée",
    "landmineHint": "Landmine : seule l’extrémité libre est chargée. L’autre extrémité est fixée au pivot au sol."
  },
  "app": {
    "title": "JackedLogs",
    "tagline": "Musculation, consignée sans détour.",
    "signedInAs": "Connecté en tant que <bold>{{email}}</bold>.",
    "signOut": "Se déconnecter",
    "loading": "Chargement…",
    "checking": "vérification…"
  },
  "auth": {
    "signIn": "Se connecter",
    "signInFailed": "Échec de la connexion. Vérifie ton e-mail et ton mot de passe.",
    "createAccount": "Créer un compte",
    "email": "E-mail",
    "emailPlaceholder": "email@exemple.com",
    "password": "Mot de passe",
    "passwordHint": "Au moins 10 caractères avec majuscule, minuscule et un chiffre.",
    "switchToSignUp": "Pas de compte ? Créez-en un.",
    "switchToSignIn": "Déjà un compte ? Connectez-vous.",
    "submitting": "En cours…",
    "confirmTitle": "Confirmez votre e-mail",
    "confirmHelp": "Un code a été envoyé à <bold>{{email}}</bold>. Collez-le ci-dessous pour finaliser la création du compte.",
    "confirmCode": "Code de confirmation",
    "confirmSubmit": "Confirmer",
    "confirming": "Confirmation…",
    "resendCode": "Renvoyer le code",
    "resentInfo": "Code renvoyé. Vérifiez votre boîte de réception.",
    "confirmedNowSignIn": "Compte confirmé. Connectez-vous pour continuer.",
    "forgotLink": "Mot de passe oublié ?",
    "forgotTitle": "Réinitialiser le mot de passe",
    "forgotIntro": "Indique ton email, on t'envoie un code pour réinitialiser le mot de passe.",
    "forgotSendCode": "Envoyer le code",
    "forgotCodeSent": "Code envoyé. Vérifie ta boîte mail.",
    "forgotConfirmHelp": "Code envoyé à <bold>{{email}}</bold>. Saisis-le ci-dessous avec le nouveau mot de passe.",
    "forgotResetSubmit": "Réinitialiser",
    "forgotResetDone": "Mot de passe mis à jour. Connecte-toi avec le nouveau.",
    "newPassword": "Nouveau mot de passe",
    "backToSignIn": "Retour à la connexion"
  },
  "dashboard": {
    "meTitle": "Aller-retour authentifié — /api/me",
    "healthTitle": "État de l'API",
    "exportData": "Exporter mes données",
    "deleteAccount": "Supprimer mon compte",
    "exporting": "Préparation de l'export…",
    "deleting": "Suppression…",
    "deleteConfirm": "Cette action supprimera définitivement votre compte et toutes vos données. Tapez SUPPRIMER pour confirmer.",
    "deleteCancel": "Annuler",
    "deletePlaceholder": "SUPPRIMER",
    "deleteSuccess": "Compte supprimé.",
    "exportFilename": "jackedlogs-export-{{date}}.json",
    "privacyTitle": "Confidentialité",
    "privacyHelp": "Exportez tout en JSON ou supprimez le compte définitivement. Les suppressions sont irréversibles."
  },
  "privacy": {
    "linkLabel": "Confidentialité",
    "title": "Politique de confidentialité",
    "lastUpdated": "Dernière mise à jour : 27 août 2026 (base légale)",
    "intro": "Metria est conçue et exploitée par Heraion. Cette politique explique ce que nous collectons, où les données résident et quels sont vos droits.",
    "section1Title": "Ce que nous collectons",
    "section1Body": "Strictement le nécessaire au fonctionnement du service : votre adresse e-mail (identifiant du compte), un mot de passe haché (géré par Amazon Cognito — le clair ne quitte jamais votre navigateur) et les données d'entraînement que vous saisissez. Nous ne collectons ni nom, ni adresse, ni numéro de téléphone, ni date de naissance, ni empreinte analytique. Le poids corporel est optionnel : si vous le renseignez dans le profil, l'app peut calculer la charge effective sur les exercices au poids du corps (dips, tractions, etc.). Il est traité comme une donnée de santé de catégorie particulière au sens de l'art. 9 RGPD et de l'art. 5 let. c LPD : jamais agrégé, jamais journalisé, supprimé avec le reste des données à la fermeture du compte.",
    "section2Title": "Où vivent les données",
    "section2Body": "Toutes les données sont stockées dans la région AWS eu-central-2 (Zurich, Suisse). L'authentification fonctionne sur Amazon Cognito ; les données structurées sur Amazon DynamoDB ; les fichiers statiques sur Amazon CloudFront. Nous n'utilisons aucun service tiers d'analytics, de publicité ou de pistage.",
    "section3Title": "Vos droits",
    "section3Body": "Vous pouvez à tout moment exporter l'intégralité de vos données (JSON) ou supprimer définitivement votre compte depuis le tableau de bord. La suppression efface l'enregistrement d'authentification et tout enregistrement lié à votre compte, sans soft-delete.",
    "section4Title": "Contact",
    "section4Body": "Questions ou demandes : {{email}}.",
    "section5Title": "Base légale",
    "section5Body": "La base légale du traitement, au sens de la nLPD suisse et du RGPD UE, est votre consentement à l'inscription et l'intérêt légitime de fournir le service demandé. Cette politique sera mise à jour avant toute extension du périmètre.",
    "back": "Retour"
  },
  "errors": {
    "generic": "Une erreur s'est produite."
  },
  "feedback": {
    "title": "Envoyer un retour",
    "help": "Bug trouvé, fonctionnalité souhaitée ou autre ? Écris-le ici. Les messages arrivent dans la boîte admin.",
    "kindLabel": "Type",
    "kind_bug": "Bug",
    "kind_feature": "Demande de fonctionnalité",
    "kind_other": "Autre",
    "bodyLabel": "Que s'est-il passé ?",
    "bodyPlaceholder": "Décris ce que tu as vu, ce que tu attendais et comment le reproduire.",
    "send": "Envoyer",
    "sending": "Envoi…",
    "sentFlash": "Merci — envoyé.",
    "sentHint": "On le traitera à la prochaine session. Tu peux fermer.",
    "close": "Fermer",
    "errEmpty": "Écris quelque chose avant d'envoyer.",
    "errSubmit": "Échec de l'envoi. Réessaie dans un instant.",
    "errRateLimit": "Trop d'envois dans la dernière heure. Réessaie plus tard.",
    "inboxTitle": "Boîte de retours",
    "loading": "Chargement des retours…",
    "empty": "Aucun retour à afficher.",
    "filterAll": "Tous",
    "loadMore": "Charger plus",
    "status_open": "Ouvert",
    "status_in_progress": "En cours",
    "status_shipped": "Livré",
    "status_wontfix": "Non corrigé",
    "priorityLabel": "Priorité",
    "priorityNone": "Aucune",
    "statusLabel": "Statut",
    "head_open": "{{count}} ouverts",
    "head_in_progress": "{{count}} en cours",
    "head_shipped": "{{count}} livrés",
    "head_wontfix": "{{count}} non corrigés",
    "headTotal": "{{count}} au total"
  },
  "profile": {
    "title": "Profil",
    "loading": "Chargement du profil…",
    "name": "Nom affiché",
    "namePlaceholder": "Comment souhaitez-vous être appelé(e) ?",
    "role": "Rôle",
    "roleCoach": "Coach",
    "roleAthlete": "Athlète",
    "roleBoth": "Les deux",
    "ageBucket": "Tranche d'âge (facultatif)",
    "ageBucketHelp": "Utilisée uniquement pour les statistiques de groupe anonymes opt-in. Reste vide si vous ne la remplissez pas.",
    "ageBucketNone": "Préfère ne pas répondre",
    "unitsPreference": "Unité préférée",
    "unitsPreferenceHelp": "Les poids sont toujours stockés en kilogrammes. Vous pourrez changer l'unité de saisie pour chaque série.",
    "preferredFigure": "Figure du corps sur la bodymap",
    "preferredFigureHelp": "Choisis la figure utilisée par la muscle map. Découplé du sexe — on ne demande pas. Le web affiche uniquement la figure masculine jusqu'au changement de librairie ; le mobile respecte les deux.",
    "figure_masculine": "Masculine",
    "figure_feminine": "Féminine",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "saved": "Profil enregistré.",
    "agePrefix_under_18": "Moins de 18 ans",
    "age_18-24": "18-24",
    "age_25-29": "25-29",
    "age_30-34": "30-34",
    "age_35-39": "35-39",
    "age_40-44": "40-44",
    "age_45-49": "45-49",
    "age_50-54": "50-54",
    "age_55-59": "55-59",
    "age_60-64": "60-64",
    "age_65-69": "65-69",
    "age_70-plus": "70+",
    "bodyweight": "Poids corporel (optionnel)",
    "bodyweightPlaceholder": "p. ex. 78",
    "bodyweightHelp": "Sert uniquement à calculer la charge effective sur les exercices au poids du corps. Jamais agrégé, jamais journalisé, supprimé avec le compte.",
    "errBodyweight": "Saisis un poids entre 20 et 300 kg (ou l'équivalent en lb).",
    "apk": {
      "title": "APK Android (build de test)",
      "hint": "Build de test réservé à la famille. Sur Android, active « Installer depuis des sources inconnues » dans le navigateur, puis ouvre le fichier.",
      "download": "Télécharger l'APK"
    },
    "email": "E-mail",
    "metaTitle": "Session"
  },
  "workout": {
    "title": "Entraînements",
    "loading": "Chargement des entraînements…",
    "empty": "Aucun entraînement enregistré.",
    "logNew": "Enregistrer un entraînement",
    "startedAt": "Quand",
    "exercise": "Exercice",
    "exercisePlaceholder": "Choisir un exercice",
    "errPickExercise": "Choisis un exercice dans le catalogue.",
    "catalogEmptyCoach": "Le catalogue est vide. Ajoute au moins un exercice avant d'enregistrer un entraînement.",
    "catalogEmptyAthlete": "Le catalogue est vide. L'un de tes coachs doit ajouter les exercices avant que tu puisses enregistrer un entraînement.",
    "setsLegend": "Séries",
    "set": "Série",
    "reps": "Répétitions",
    "amrapHint": "AMRAP — dépasse le seuil prescrit",
    "weight": "Poids",
    "extra": "Extra (+/−)",
    "unit": "Unité",
    "rpe": "RPE",
    "addSet": "Ajouter une série",
    "removeSet": "Supprimer la série",
    "notes": "Notes (facultatif)",
    "setNoteToggle": "Ajouter une note à cette série",
    "setNotePlaceholder": "Ce qui était différent sur cette série",
    "draftRecoveryHeadline": "Tu as un entraînement non terminé du {{when}}.",
    "draftRecoveryContinue": "Continuer",
    "draftRecoveryDiscard": "Abandonner",
    "maxBumpAvailable": "{{exercise}} : nouveau MAX à {{value}}",
    "maxBumpConfirm": "↑ Confirmer",
    "maxBumpSaving": "Enregistrement…",
    "prefillFromDate": "Pré-remplir depuis {{date}} ?",
    "prefillAccept": "Utiliser",
    "prefillDismiss": "Passer",
    "savePromptTitle": "Vérifie avant d'enregistrer",
    "savePromptContinue": "Retour à la séance",
    "savePromptAnyway": "Enregistrer quand même",
    "unmarkedPromptBody": "{{count}} séries avec des valeurs mais sans marque de fin.",
    "unmarkedPromptFail": "Marquer échouées et enregistrer",
    "unmarkedPromptComplete": "Marquer faites et enregistrer",
    "outlierPromptBody": "{{count}} entrées semblent inhabituelles :",
    "outlierItem": "{{exercise}} : {{weight}} (max historique {{expected}})",
    "outlierE1rmItem": "{{exercise}} : 1RM estimé {{e1rm}} (max historique {{expected}})",
    "outlierPerImplementItem": "{{exercise}} : {{weight}} fait environ le double de ton habituel {{expected}} — tu as saisi le poids d'UN seul haltère ou le total des deux ?",
    "outlierRepsItem": "{{exercise}} : {{reps}} répétitions — semble trop élevé",
    "outlierZeroWeightItem": "{{exercise}} : {{reps}} répétitions sans charge",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "saved": "Entraînement enregistré.",
    "savedEdit": "Entraînement mis à jour.",
    "savedEditOldRemains": "Entraînement mis à jour, mais la version précédente reste dans l'historique. Supprime-la manuellement.",
    "deleted": "Entraînement supprimé.",
    "cancel": "Annuler",
    "errNoSets": "Ajoutez au moins une série valide.",
    "creatingTitle": "Nouvel entraînement",
    "editingTitle": "Modifier l'entraînement",
    "exerciseN": "Exercice {{n}}",
    "addExercise": "Ajouter un autre exercice",
    "removeExercise": "Retirer l'exercice",
    "removeExerciseConfirm": "Retirer {{name}} de cet entraînement ? Les séries déjà enregistrées seront perdues.",
    "groupAlignTitle": "Nombre de séries différent",
    "groupAlignBody": "Les membres de ce groupe ont entre {{shortest}} et {{longest}} séries. Les aligner pour que les tours coïncident ?",
    "groupAlignPad": "+ Aligner sur {{n}}",
    "groupAlignTrim": "− Réduire à {{n}}",
    "groupAlignTrimWarning": "Réduire supprime des séries déjà enregistrées, sans retour possible.",
    "groupAlignTrimHint": "Supprime les séries en trop de chaque membre du groupe. Sans retour possible.",
    "groupAlignKeep": "Laisser ainsi",
    "splitGroup": "Séparer",
    "splitGroupTitle": "Séparer ce groupe ?",
    "splitGroupBody": "Les exercices conservent leurs séries et restent dans la séance, simplement dissociés. Vous pouvez les regrouper à nouveau quand vous voulez.",
    "splitGroupConfirm": "Séparer",
    "removeRoundConfirmTitle": "Supprimer ce tour ?",
    "removeRoundConfirmBody": "Le tour {{n}} de {{names}} sera supprimé en bloc.",
    "bilateral": "Bilatéral",
    "unilateral": "Unilatéral",
    "edit": "Modifier",
    "repeat": "Répéter",
    "delete": "Supprimer",
    "deleting": "Suppression…",
    "deleteConfirm": "Supprimer cet entraînement ?",
    "distance": "m",
    "duration": "s",
    "cardioDuration": "Durée",
    "cardioDistance": "Distance",
    "cardioWeight": "Charge",
    "cardioHr": "FC moy",
    "cardioCalories": "Calories",
    "cardioOptionalsShow": "Autres champs",
    "cardioOptionalsHide": "Autres champs",
    "dateEditor": "Date et durée",
    "dateLabel": "Date",
    "startTimeLabel": "Début",
    "endTimeLabel": "Fin",
    "durationLabel": "Durée",
    "side": "Côté",
    "sideLeft": "Gauche",
    "sideRight": "Droit",
    "sideBoth": "Les deux",
    "showRpe": "Suivre la RPE",
    "showDuration": "Suivre la durée",
    "rir": "RIR {{n}}",
    "swap": "Remplacer",
    "swapHint": "Banc occupé ? Choisissez un exercice similaire.",
    "descriptionToggle": "Afficher / masquer la description",
    "failShort": "F",
    "failToggle": "Marquer la série comme ratée",
    "failHint": "Dernière rep manquée. Comptée dans le volume, exclue des PR.",
    "startRest": "Démarrer le minuteur de repos",
    "restStartDefault": "Démarrer le repos ({{n}}s)",
    "restStartCustom": "Démarrer le repos ({{n}}s, défaut de l'exercice)",
    "setComplete": "Marquer la série comme finie",
    "setCompleteHint": "Tamponne la série et lance un repos de {{n}}s.",
    "setCompleteHintCustom": "Tamponne la série et lance un repos de {{n}}s (défaut de l'exercice).",
    "setUndo": "Annuler la validation",
    "setUndoHint": "Touche encore pour annuler et remettre le minuteur à zéro.",
    "restLeft": "Repos",
    "restDone": "Temps écoulé",
    "restStop": "Stop",
    "restPause": "Pause",
    "restResume": "Reprendre",
    "restSound": "Bip à la fin du repos",
    "instructions": "Consignes du coach (optionnel)",
    "instructionsPlaceholder": "Focus de la séance, à sauter en cas de temps court, intention.",
    "lastTime": "Précéd.",
    "lastToday": "aujourd'hui",
    "lastDaysAgo": "il y a {{n}}j",
    "dropsetShort": "Drop",
    "dropsetToggle": "Ajouter une chaîne dropset",
    "dropsetHint": "Enchaîne d'autres reps sans repos.",
    "dropsetTitle": "Dropset",
    "dropsetVariant": "Variante",
    "dropsetClassical": "Classique (charge réduite)",
    "dropsetMyorep": "Myo-rep (même charge)",
    "dropsetHintClassical": "Baisse la charge de 10 à 30 % et continue jusqu'à l'échec. Pas de repos.",
    "dropsetHintMyorep": "Même charge, moins de reps, 10–20 s de respiration, on répète.",
    "dropsetSameLoad": "= dessus",
    "dropsetAddStep": "Ajouter un drop",
    "dropsetRemove": "Retirer",
    "dropsetRemoveConfirm": "Tu as {{n}} drop steps. Reconvertir en série classique et les supprimer ?",
    "dropsetRemoveStep": "Retirer le drop",
    "groupLabel": "Groupe",
    "groupNone": "(aucun)",
    "groupCreate": "Créer",
    "groupNewSuperset": "Nouveau superset",
    "groupNewCircuit": "Nouveau circuit",
    "groupJoinExisting": "Rejoindre un groupe existant",
    "groupLeave": "Dégrouper",
    "groupSharedHint": "Partagé. Ouvre un autre exercice et sélectionne le même groupe dans la liste pour les apparier.",
    "supersetN": "Superset {{n}}",
    "circuitN": "Circuit {{n}}",
    "supersetDerived": "Superset (auto)",
    "supersetDerivedTitle": "Détecté à partir de l'alternance des sets dans cette séance",
    "playActiveTitle": "Exercice actif — set complété le plus récent",
    "errGroupKindMixed": "Un même groupe ne peut pas mélanger superset et circuit. Choisis un seul type.",
    "exerciseNew": "Nouvel exercice",
    "cardMenu": "Options de l'exercice",
    "menuReplace": "Remplacer l'exercice",
    "menuGroup": "Groupe / superset",
    "menuMoveUp": "Déplacer vers le haut",
    "menuMoveDown": "Déplacer vers le bas",
    "menuShowNotes": "Afficher les notes",
    "menuHideNotes": "Masquer les notes",
    "menuShowDescription": "Afficher la description",
    "menuHideDescription": "Masquer la description",
    "tipAlternatives": "Exercices alternatifs",
    "tipCoachNote": "Note du coach",
    "perImplementHint": "Tu en utilises deux, ou un côté à la fois ? Saisis le poids d'un seul. L'app compte les deux (×2).",
    "tipProgramNote": "Dans ce programme",
    "tipNoAlternatives": "Aucun exercice similaire au catalogue",
    "tipClose": "Fermer",
    "painBanner": {
      "red": "Sollicite un muscle douloureux",
      "yellow": "Attention : charge un muscle signalé",
      "green": "Aucun risque signalé"
    },
    "setCycleHint": "Tape : fait · encore : raté · encore : annuler",
    "setStatePending": "Série ouverte",
    "setStateDone": "Série terminée",
    "setStatePr": "Série terminée, record personnel",
    "setStateFailed": "Série marquée comme ratée",
    "prShort": "🏆",
    "addDrop": "+ drop",
    "groupBannerSuperset": "SUPERSET",
    "groupBannerCircuit": "CIRCUIT",
    "groupAutoTag": "AUTO",
    "groupAutoConfirm": "Verrouiller",
    "groupAutoConfirmAria": "Verrouille le groupe : arrête le détecteur et garde ces exercices liés",
    "groupAutoDismiss": "Annuler",
    "groupAutoDismissAria": "Ignore la détection : ces exercices redeviennent individuels",
    "groupAddSetAll": "Ajouter une série à tous",
    "nameLabel": "Nom (facultatif)",
    "namePlaceholder": "Ex. Push A · Lower Quad-Dominant",
    "durationStepperA11y": "ajustement de durée",
    "rirLabel": "RIR",
    "showRir": "Suivre la RIR",
    "maxDownA11y": "Le MAX a peut-être baissé",
    "animationOf": "Animation de {{name}}",
    "animationZoomHint": "Ouvre l'animation en plein écran",
    "closeAnimation": "Fermer l'animation",
    "showAnimation": "Afficher l'animation",
    "showBodyMap": "Afficher les muscles sollicités",
    "pageOf": "{{current}} sur {{total}}",
    "pagerDot": "{{target}}, {{current}} sur {{total}}"
  },
  "program": {
    "title": "Programmes",
    "help": "Cycles d'entraînement multi-semaines. La phase 5.1 livre la coque : nom, semaines, séances par semaine. Le builder de slots et de progression arrive ensuite.",
    "new": "Nouveau programme",
    "newTitle": "Nouveau programme",
    "name": "Nom",
    "namePlaceholder": "ex. Powerbuilding 6 semaines",
    "cycleWeeks": "Semaines du cycle",
    "sessionsPerWeek": "Séances par semaine",
    "description": "Description",
    "descriptionPlaceholder": "À quoi sert le cycle, à qui il s'adresse, notes pour les athlètes.",
    "create": "Créer",
    "creating": "Nouveau programme : {{name}}",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "deleteConfirm": "Confirmer ?",
    "deleteConfirmYes": "Oui, supprimer",
    "loading": "Chargement des programmes…",
    "empty": "Aucun programme. Crée-en un pour planifier un cycle multi-semaines.",
    "statusDraft": "Brouillon",
    "statusActive": "Actif",
    "statusArchived": "Archivé",
    "cycleWeeksLabel": "Cycle de {{n}} semaines",
    "sessionsPerWeekLabel": "{{n}}× / semaine",
    "slotCount": "{{n}} slot(s)",
    "skeletonHint": "Coque seulement. Les slots se remplissent dans la phase suivante.",
    "sessionDefaultName": "Séance {{n}}",
    "edit": "Modifier",
    "editing": "Modification : {{name}}",
    "backToList": "Retour aux programmes",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "errSave": "Impossible d'enregistrer le programme.",
    "metaLegend": "Programme",
    "status": "Statut",
    "metaCyclesLive": "Les modifications de structure (jours, semaines) s'appliquent immédiatement",
    "ordinalSession": "{{n}}ᵉ séance",
    "sessionName": "Nom de la séance",
    "slotN": "Slot {{n}}",
    "addSlot": "Ajouter un slot",
    "removeSlot": "Supprimer",
    "moveUp": "Déplacer vers le haut",
    "moveDown": "Déplacer vers le bas",
    "exercise": "Exercice",
    "exercisePick": "Choisis un exercice",
    "setsLegend": "Séries",
    "addSet": "Ajouter une série",
    "removeSet": "Supprimer la série",
    "reps": "Reps",
    "setNotesPlaceholder": "Note pour la série (optionnel)",
    "set": "Série",
    "intensityKind": "Intensité",
    "intensityNone": "Libre",
    "intensityPercent": "% du MAX",
    "intensityAbs": "kg (absolu)",
    "intensityRpe": "RPE",
    "intensity_percent-of-max": "Pourcentage",
    "intensity_absolute": "Poids (kg)",
    "intensity_rpe": "RPE",
    "weekShort": "S{{n}}",
    "previewShow": "Aperçu",
    "previewHide": "Cacher l'aperçu",
    "previewMuscles": "Muscles sollicités",
    "previewSets": "{{n}} séries",
    "previewEmptySession": "Aucun slot dans cette séance.",
    "previewEmptyProgram": "Aucun slot pour l'instant. Ouvre Modifier pour en ajouter.",
    "start": "Lancer une séance",
    "startCancel": "Annuler",
    "startGo": "Lancer",
    "starting": "Lancement…",
    "startWeek": "Semaine",
    "startSession": "Séance",
    "progressNext": "Suivante : S{{w}} · Séance {{s}}",
    "instructions": "Instructions",
    "instructionsPlaceholder": "Tempo, durée de pause, focus technique, RPE cible.",
    "amrapLastSet": "AMRAP sur la dernière série",
    "maxAttempt": "Tentative 1MAX",
    "amrapBadge": "AMRAP",
    "maxBadge": "1MAX",
    "slotCycleHint": "Appliqué sur les {{n}} semaines du cycle.",
    "catalogLoading": "Chargement du catalogue d'exercices…",
    "builderComingSoon": "Le builder de slots et de progression arrive en Phase 5.2. Pour l'instant cela crée une coque vide, supprimable ou à remplir plus tard.",
    "errCycleWeeks": "Les semaines doivent être entre 1 et 12.",
    "errSessionsPerWeek": "Les séances par semaine doivent être entre 1 et 7.",
    "errName": "Le nom du programme est requis.",
    "errEmptyDay": "Chaque jour d'entraînement doit avoir au moins un exercice.",
    "errSchema": "Données de programme invalides.",
    "errCreate": "Impossible de créer le programme.",
    "errCode": {
      "sessionNameEmpty": "Chaque jour d'entraînement doit avoir un nom.",
      "slotNoExercise": "Choisis un exercice pour chaque emplacement.",
      "slotNoSets": "Chaque exercice doit avoir au moins une série.",
      "slotAllWeeksInactive": "Un exercice est désactivé sur toutes les semaines. Active une semaine ou retire-le.",
      "rowWidthMismatch": "Une ligne de séries ne correspond pas au nombre de semaines. Rouvre l'exercice et réessaie.",
      "invalidReps": "Vérifie les répétitions : utilise un nombre comme 8, ou 8+ pour l'AMRAP.",
      "groupKindMixed": "Un superset mélange des types de séries. Donne le même type à ses exercices.",
      "schemaInvalid": "Données de programme invalides.",
      "noSession": "Il n'y a aucune séance à enregistrer.",
      "planNameEmpty": "Le nom du plan est requis.",
      "planNoExercises": "Ajoute au moins un exercice au plan.",
      "invalidIntensityValue": "Vérifie la valeur d'intensité : ce doit être un nombre.",
      "weightOutOfRange": "Ce poids est hors plage.",
      "pctOutOfRange": "Le pourcentage doit être entre 0 et 200.",
      "rpeOutOfRange": "Le RPE doit être entre 1 et 10.",
      "rirOutOfRange": "Le RIR doit être entre 0 et 10.",
      "unknownIntensityKind": "Type d'intensité inconnu.",
      "invalidSeconds": "Vérifiez les secondes : une série chronométrée demande une durée, en secondes entières jusqu'à 3600."
    },
    "cardMenu": "Menu du slot",
    "menuGroup": "Groupe",
    "groupNone": "Aucun groupe",
    "groupJoinExisting": "Rejoindre un groupe",
    "groupCreate": "Créer",
    "groupNewSuperset": "Nouveau superset",
    "groupNewCircuit": "Nouveau circuit",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuit {{letter}}",
    "assignTo": "Assigner aux athlètes",
    "assignToHelp": "Le programme est ajouté à la bibliothèque de chaque athlète. Une relation coach active avec toi est requise.",
    "assignSelf": "Toi (auteur)",
    "addAssignee": "Ajouter",
    "removeAssignee": "Retirer",
    "assigneePlaceholder": "athlete@exemple.com",
    "follow": "Suivre",
    "unfollow": "Ne plus suivre",
    "followHint": "Suivre ce programme (il apparaît dans En cours)",
    "publish": "Publier",
    "unpublish": "Repasser en brouillon",
    "publishAndFollow": "Publier et suivre",
    "publishHint": "Rendre ce programme disponible pour le suivre",
    "chipDraft": "Brouillon",
    "chipPublished": "Publié",
    "chipFollowed": "Suivi",
    "kindShortAbsolute": "KG",
    "kindShortAbsoluteLb": "LB",
    "kindShortPercent": "%MAX",
    "kindShortHistory": "HIST",
    "kindShortRpe": "RPE",
    "kindShortRir": "RIR",
    "languageUndeclared": "Langue",
    "languageA11y": "Langue d'écriture",
    "languageSwitchQuestion": "Dans quelle langue écris-tu ?",
    "languageDeclareQuestion": "Dans quelle langue ce programme est-il écrit ?",
    "languageFootnote": "Les traductions sont facultatives : un programme dans une seule langue est complet.",
    "languageDeclareFootnote": "Rien n'est traduit : cela indique seulement la langue.",
    "languageAuto": "Traduction automatique",
    "languageNotYetWritten": "Pas encore de version en {{lang}}. Le texte en {{original}} reste en place.",
    "setBound": "Limite",
    "boundReps": "Reps",
    "boundTime": "Temps",
    "boundOpen": "Libre",
    "workSeconds": "Effort (s)",
    "restSeconds": "Repos (s)",
    "restSecondsPlaceholder": "auto",
    "prescribeTime": "Temps",
    "prescribeTimeA11y": "Prescrire l'effort et le repos en secondes",
    "seconds": "Secondes",
    "amrapNotWithTime": "Une série de {{secs}}s ne peut pas être un AMRAP : un plan ne peut pas te demander combien tu en feras. Enlève le + ou le temps.",
    "workSecondsRequired": "Quelle durée ?"
  },
  "me": {
    "targets": {
      "title": "Objectifs",
      "historyByCoach": "Votre coach",
      "errNotFound": "Impossible de trouver vos objectifs. Revenez en arrière et réessayez."
    }
  },
  "coach": {
    "title": "Coach et athlètes",
    "subtitle": "Athlètes que tu entraînes et coachs qui t'entraînent. L'invitation exige le consentement des deux parties avant que les assignations puissent circuler.",
    "subLabel": "sub",
    "inviteAthleteLabel": "Inviter un athlète par email",
    "invitePlaceholder": "athlete@exemple.com",
    "inviteNotePlaceholder": "Note (facultatif)",
    "inviteSend": "Envoyer l'invitation",
    "inviteSending": "Envoi…",
    "inviteSent": "Invitation envoyée. L'athlète la verra à sa prochaine connexion.",
    "athletesHeading": "Athlètes que j'entraîne",
    "coachesHeading": "Coachs qui m'entraînent",
    "athletesEmpty": "Aucun athlète. Invites-en un ci-dessus.",
    "pendingInLabel": "En attente de ta réponse",
    "pendingOutLabel": "En attente de leur réponse",
    "activeLabel": "Actifs",
    "accept": "Accepter",
    "decline": "Refuser",
    "cancel": "Annuler l'invitation",
    "revoke": "Révoquer",
    "leave": "Quitter le coach",
    "busy": "En cours…",
    "loading": "Chargement…",
    "loadFailed": "Échec du chargement. Recharge pour réessayer.",
    "errCode": {
      "invalid_email": "Email mal formée.",
      "email_not_found": "Aucun compte vérifié avec cet email.",
      "peer_required": "Indique une email ou un sub.",
      "edge_exists": "Une relation existe déjà avec ce pair.",
      "userpool_not_configured": "Serveur mal configuré : pool d'utilisateurs indisponible.",
      "io_error": "Erreur réseau ou serveur. Réessaie.",
      "not_pending": "Cette invitation n'est plus en attente.",
      "wrong_party": "Seule l'autre partie peut accepter cette invitation."
    },
    "dashboard": {
      "title": "Vue d'ensemble de l'équipe",
      "unnamedAthlete": "Athlète",
      "empty": "Aucun athlète pour l'instant",
      "emptySub": "Invitez des athlètes depuis Coach et athlètes pour les voir ici.",
      "loading": "Chargement de votre équipe…",
      "loadFailed": "Impossible de charger l'équipe. Actualisez pour réessayer.",
      "noProgram": "Aucun programme",
      "kpiAssigned": "Athlètes",
      "kpiActive": "Actifs cette semaine",
      "kpiAttention": "À surveiller",
      "kpiAdherence": "Adhérence moyenne",
      "kpiSessions": "Séances cette semaine",
      "adherence": "adhérence",
      "lastToday": "aujourd'hui",
      "lastNever": "jamais entraîné",
      "lastDaysAgo": "il y a {{count}}j",
      "flagStale": "Ne s'entraîne pas",
      "flagUnderTarget": "Sous l'objectif",
      "flagOnTrack": "Dans les temps",
      "flagNoProgram": "Aucun programme"
    },
    "detail": {
      "back": "Retour à l'équipe",
      "maxesTitle": "MAX actuels",
      "maxesEmpty": "Aucun MAX enregistré",
      "rhythmSummary": "moyenne {{avg}}/semaine sur {{weeks}} semaines · semaine dernière : {{last}}",
      "effortTitle": "Couverture de l'effort",
      "effortLabel": "séries avec RIR enregistré",
      "effortSummary": "{{tagged}} séries sur {{counted}} comptées, échauffements inclus",
      "effortEra": "Les données d'effort commencent le {{date}} · {{count}} séries antérieures ne sont pas comptées",
      "effortNone": "Aucune série ne porte encore de valeur d'effort : les chiffres des séries difficiles et des cibles n'ont rien sur quoi s'appuyer.",
      "effortError": "Impossible de charger les données d'effort.",
      "maxesSeeAll": "Tout afficher (+{{count}})",
      "maxesShowFewer": "Réduire"
    },
    "targets": {
      "eyebrow": "Objectifs hebdomadaires",
      "edit": "Modifier les objectifs",
      "degradedHint": "Cet athlète n'a pas encore d'objectifs hebdomadaires. Définissez-en pour évaluer sa semaine par rapport à un but.",
      "noGrant": "Lecture seule — l'athlète ne vous a pas accordé la modification des objectifs.",
      "historyTitle": "Historique des modifications",
      "historyEmpty": "Aucune modification pour l'instant.",
      "historyByYou": "Vous",
      "historyTruncated": "Affichage des 1000 modifications les plus récentes.",
      "histGeneric": "Objectifs mis à jour",
      "histSet": "défini à {{value}}",
      "histRemoved": "supprimé",
      "histChanged": "{{from}} → {{to}}",
      "histLine": "{{label}} · {{metric}} : {{body}}",
      "historyLoading": "Chargement…",
      "errLoad": "Impossible de charger ces objectifs. Revenez en arrière et réessayez.",
      "errStale": "Ces objectifs ont changé pendant votre modification. Rechargez et réappliquez.",
      "errNoGrant": "L'athlète ne vous a pas accordé la modification des objectifs.",
      "errNotCoach": "Vous n'êtes pas le coach de cet athlète.",
      "errMultiAssignee": "Ce programme est partagé par plusieurs athlètes.",
      "errRetry": "Chargement en cours — réessayez dans un instant.",
      "errNotFound": "Ce programme n'existe plus.",
      "errOffline": "Échec de l'enregistrement. Vérifiez votre connexion et réessayez."
    }
  },
  "plans": {
    "title": "Plans",
    "help": "Prépare une séance pour toi. Les cibles peuvent être en kg absolus ou en pourcentage du MAX, converties en kg au démarrage du plan.",
    "loading": "Chargement des plans…",
    "empty": "Aucun plan pour l'instant. Ajoutes-en un pour préparer ta séance.",
    "todayPill": "Aujourd'hui",
    "add": "Ajouter un plan",
    "edit": "Modifier",
    "start": "Démarrer",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "saved": "Plan enregistré.",
    "savedEdit": "Plan mis à jour.",
    "deleted": "Plan supprimé.",
    "delete": "Supprimer",
    "deleting": "Suppression…",
    "deleteConfirm": "Supprimer ce plan ?",
    "creatingTitle": "Nouveau plan",
    "editingTitle": "Modifier le plan",
    "name": "Nom",
    "namePlaceholder": "p. ex. Jour squat",
    "scheduledFor": "Date prévue (optionnel)",
    "pickDate": "Choisis une date",
    "pickDateHint": "Ouvre le sélecteur de date",
    "clearDate": "Effacer la date",
    "noDate": "Non définie",
    "notes": "Notes (optionnel)",
    "rpeEnabledLabel": "Afficher la colonne RPE dans le Logger",
    "rpeEnabledHelp": "Quand activé, les sessions démarrées depuis ce plan s'ouvrent avec la colonne RPE visible. L'athlète peut quand même la basculer par session.",
    "exercise": "Exercice",
    "exercisePlaceholder": "Choisis un exercice",
    "exerciseN": "Exercice {{n}}",
    "removeExercise": "Retirer l'exercice",
    "addExercise": "Ajouter un autre exercice",
    "setsLegend": "Séries",
    "targetReps": "Reps",
    "targetWeight": "Poids",
    "targetKind": "Unité",
    "targetRpe": "RPE",
    "noMaxYet": "pas de MAX",
    "addSet": "Ajouter une série",
    "removeSet": "Retirer la série",
    "statusDraft": "Brouillon",
    "statusScheduled": "Planifié",
    "statusCompleted": "Terminé",
    "statusSkipped": "Sauté",
    "errNotSignedIn": "Connexion requise.",
    "errNameRequired": "Donne un nom au plan.",
    "errPickExercise": "Choisis un exercice du catalogue.",
    "errNoSets": "Ajoute au moins une série valide.",
    "errGroupKindMixed": "Deux exercices partagent un group id mais l'un est un superset et l'autre un circuit. Choisis-en un et resauvegarde.",
    "assignTo": "Assigner aussi à",
    "assignToHelp": "Tape une adresse email et appuie sur Entrée. L'adresse doit déjà avoir un compte, sinon le plan est rejeté.",
    "addAssignee": "Ajouter",
    "removeAssignee": "Retirer",
    "assigneePlaceholder": "nom@exemple.com",
    "exerciseNew": "Choisir un exercice",
    "setIndex": "Série {{n}}",
    "cardMenu": "Menu de la carte",
    "menuGroup": "Groupe",
    "menuMoveUp": "Monter",
    "menuMoveDown": "Descendre",
    "groupNone": "Aucun groupe",
    "groupJoinExisting": "Rejoindre un groupe",
    "groupCreate": "Créer",
    "groupNewSuperset": "Nouveau superset",
    "groupNewCircuit": "Nouveau circuit",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuit {{letter}}",
    "details": "Détails",
    "exercisesLabel": "Exercices",
    "editorEmpty": "Aucun exercice pour l’instant. Ajoutez-en un pour composer ce plan.",
    "selectExercisePrompt": "Sélectionnez un exercice pour modifier ses séries.",
    "addExerciseCta": "Ajouter un exercice",
    "removeExerciseConfirm": "Supprimer cet exercice ?",
    "removeExerciseHint": "Touchez une fois pour confirmer, puis touchez à nouveau pour supprimer.",
    "collapseExercise": "Réduire l’exercice",
    "supersetTag": "SUPERSET",
    "exerciseNoteLabel": "Note d’exercice (optionnel)"
  },
  "templates": {
    "show": "Parcourir les modèles de base",
    "hide": "Masquer les modèles",
    "help": "Plans et programmes prêts à l'emploi. Clone-en un dans ton compte — la copie t'appartient, modifie-la ou supprime-la sans toucher au modèle.",
    "loading": "Chargement des modèles…",
    "empty": "Aucun modèle disponible pour le moment.",
    "errLoad": "Impossible de charger les modèles.",
    "clone": "Cloner chez moi",
    "cloning": "Clonage…",
    "cloned": "« {{name}} » cloné.",
    "alreadyCloned": "Déjà cloné",
    "difficultyBeginner": "Débutant",
    "difficultyIntermediate": "Intermédiaire",
    "difficultyAdvanced": "Avancé",
    "planMeta": "{{n}} exercice(s)",
    "programMeta": "Cycle de {{weeks}} semaines · {{sessions}}× / semaine"
  },
  "maxes": {
    "title": "Maxes",
    "countLabel_one": "{{count}} défini",
    "countLabel_other": "{{count}} définis",
    "help": "Le MAX, c'est ce que tu peux soulever aujourd'hui, fixé par toi. Les programmes l'utilisent comme base de pourcentage. Le 1RM estimé dans Progression est purement informatif.",
    "loading": "Chargement des maxes…",
    "empty": "Aucun max défini. Ajoutes-en un pour piloter la programmation en pourcentage.",
    "add": "Ajouter un max",
    "edit": "Modifier",
    "delete": "Supprimer",
    "deleteAction": "Supprimer le MAX",
    "deleting": "Suppression…",
    "deleted": "MAX supprimé.",
    "deleteConfirm": "Supprimer le MAX de {{name}} ? L'historique est aussi supprimé. Le prochain seed depuis l'historique pourra le repopuler depuis tes séances.",
    "exercise": "Exercice",
    "exercisePlaceholder": "Choisir un exercice",
    "value": "Valeur",
    "source": "Origine",
    "sourceManual": "Saisie manuelle",
    "sourceTested": "Testé en salle",
    "sourceDerived": "Dérivé d'une série loguée",
    "sourceCalculated": "Estimé depuis l'historique",
    "sourceImported": "Importé",
    "notes": "Notes (facultatif)",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "saved": "Max enregistré.",
    "cancel": "Annuler",
    "errPickExercise": "Choisis un exercice.",
    "errInvalidValue": "Entre une valeur entre 0 et 2000.",
    "seed": {
      "start": "Suggérer depuis l'historique",
      "loading": "Lecture de l'historique…",
      "reviewIntro": "{{count}} exercices ont une série top crédible dans ton historique. Choisis ceux à utiliser comme MAX. Les exercices déjà dotés d'un MAX sont ignorés.",
      "selectAll": "Tout sélectionner",
      "selectNone": "Tout désélectionner",
      "fromSet": "depuis {{weight}} × {{reps}}",
      "cancel": "Annuler",
      "apply": "Définir {{count}} MAX",
      "applying": "Enregistrement : {{done}} / {{total}}",
      "applied": "{{count}} MAX définis depuis l'historique.",
      "noneApplicable": "Rien à définir. Soit chaque exercice a déjà un MAX, soit aucun historique avec charge n'a été trouvé.",
      "close": "Fermer"
    }
  },
  "progress": {
    "coverageTitle": "Couverture musculaire",
    "coverageSubtitle": "vs objectif hebdo",
    "coverageTopTrained": "Tes muscles les plus travaillés cette semaine.",
    "coverageLead": "Sous ton objectif hebdo : {{count}}",
    "coverageAllGood": "Chaque muscle ciblé est dans les clous cette semaine.",
    "coverageAvg": "moy {{n}}/sem",
    "coverageSeeAll": "Voir tous les muscles (+{{count}})",
    "coverageShowFewer": "Afficher moins",
    "detailsTitle": "Plus de détails",
    "detailsSubtitle": "Analyses d'entraînement approfondies",
    "period": {
      "days": "{{days}} j",
      "painDays": "7 / {{days}} j",
      "selectorLabel": "Fenêtre d’analyse"
    },
    "title": "Progression",
    "show": "Afficher",
    "hide": "Masquer",
    "help": "Le MAX est la valeur que tu fixes toi-même ; le 1RM estimé suit Epley comme référence. Le volume est la somme de poids fois répétitions sur la séance.",
    "e1rm": "1RM estimé",
    "max": "MAX",
    "maxLabel": "MAX",
    "estimatedBadge": "1RM estimé en pointillé",
    "volume": "Volume",
    "sessions": "{{n}} séances",
    "prFound": "Record personnel à {{weight}}.",
    "prUpdate": "Mettre le MAX à {{weight}}",
    "prUpdating": "Mise à jour…",
    "viewByExercise": "Par exercice",
    "viewByTag": "Par tag",
    "noTags": "Aucune séance taggée pour l'instant. Tagge les exercices dans le catalogue pour voir le volume agrégé ici.",
    "totalVolume": "Total {{weight}}",
    "recordsScope": "Records",
    "recordsAllTime": "Tout",
    "recordsThisYear": "{{year}}",
    "filterPlaceholder": "Filtrer les exercices",
    "filterCount": "{{visible}} sur {{total}}",
    "filterNoMatch": "Aucun exercice ne correspond au filtre.",
    "coverageNoData": "Rien à évaluer pour l'instant : enregistre une séance, ou fixe un objectif hebdomadaire."
  },
  "cohort": {
    "compare": "Comparer au groupe (anonyme)",
    "hide": "Masquer la comparaison",
    "loading": "Chargement du groupe…",
    "empty": "Pas encore assez de contributions pour afficher une comparaison. Le seuil est de dix personnes dans la même tranche d'âge.",
    "contributors": "Basé sur {{n}} contributions anonymes ayant renseigné leur tranche d'âge.",
    "yourGroup": "ton groupe"
  },
  "catalog": {
    "title": "Catalogue d'exercices",
    "loading": "Chargement…",
    "empty": "Aucun exercice pour l'instant.",
    "seedStarter": "Charger un jeu initial",
    "seeding": "Chargement…",
    "importTaxonomy": "Importer la bibliothèque d'exercices",
    "importTaxonomyUpsert": "Actualiser depuis la bibliothèque",
    "importing": "Importation…",
    "importDone": "Import terminé. {{created}} créés, {{upserted}} mis à jour, {{skipped}} ignorés, {{failed}} en échec.",
    "add": "Ajouter un exercice",
    "edit": "Modifier",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "create": "Créer",
    "saving": "Enregistrement…",
    "name": "Nom",
    "namePlaceholder": "ex. Squat arrière",
    "primaryMuscle": "Muscle principal (facultatif)",
    "primaryMusclePlaceholder": "ex. quadriceps",
    "primaryLabel": "Muscles principaux (au moins un)",
    "secondaryLabel": "Muscles secondaires (facultatif)",
    "addMuscle": "+ Ajouter un muscle",
    "removeMuscle": "Retirer le muscle",
    "errPrimaryRequired": "Choisis au moins un muscle principal.",
    "isBodyweight": "Exercice au poids du corps",
    "isBodyweightHelp": "Les séries enregistrent les répétitions et une charge additionnelle facultative, pas un poids à la barre.",
    "hasP1RM": "Programmable en pourcentage du MAX",
    "hasP1RMHelp": "Permet aux plans de viser une fraction du MAX pour cet exercice.",
    "defaultRest": "Repos par défaut (s)",
    "defaultRestPlaceholder": "ex. 180",
    "defaultRestHelp": "Secondes décomptées par défaut par le minuteur de repos. Vide = défaut de l'app (90 s).",
    "defaultBar": "Poids de la barre spécifique (kg)",
    "defaultBarPlaceholder": "ex. 7",
    "defaultBarHelp": "Curl bar 7, trap bar 11, landmine ~10. Le calcul des disques part de cette valeur quand tu ouvres une série de cet exercice. Vide = défaut du menu.",
    "pinnedNoteLabel": "Indice de réglage (optionnel)",
    "pinnedNotePlaceholder": "ex. Hauteur du rack 4, butées 6, pause 1s",
    "pinnedNoteHelp": "Affiché comme une bannière sous le titre de l'exercice dans le Logger. Les notes au niveau du plan ou d'un slot de programme priment lorsqu'elles sont présentes.",
    "noMuscle": "-",
    "bw": "BW",
    "p1rm": "1RM%",
    "errSlug": "Utilise des lettres latines dans le nom pour que le système puisse générer un identifiant stable.",
    "errSlugExists": "Un exercice avec ce nom existe déjà.",
    "searchPlaceholder": "Chercher un exercice…",
    "region": "Zone",
    "regionAll": "Toutes les zones",
    "region_lower": "Bas du corps",
    "region_posterior": "Chaîne postérieure",
    "region_chest": "Pectoraux",
    "region_back": "Dos",
    "region_shoulders": "Épaules",
    "region_arms": "Bras",
    "region_core": "Tronc",
    "region_cardio": "Cardio",
    "region_other": "Autre",
    "pattern": "Schéma",
    "patternAll": "Tous les schémas",
    "pattern_squat": "Squat",
    "pattern_hinge": "Hinge",
    "pattern_horizontal-push": "Poussée horizontale",
    "pattern_vertical-push": "Poussée verticale",
    "pattern_horizontal-pull": "Tirage horizontal",
    "pattern_vertical-pull": "Tirage vertical",
    "pattern_lunge": "Fente",
    "pattern_carry": "Portage",
    "pattern_core": "Tronc",
    "pattern_isolation": "Isolation",
    "pattern_cardio": "Cardio",
    "pattern_other": "Autre",
    "equipment": "Matériel",
    "equipmentAll": "Tout le matériel",
    "equipment_barbell": "Barre",
    "equipment_dumbbell": "Haltères",
    "equipment_kettlebell": "Kettlebell",
    "equipment_cable": "Poulie",
    "equipment_machine": "Machine",
    "equipment_bodyweight": "Poids du corps",
    "equipment_band": "Élastique",
    "equipment_other": "Autre",
    "clearFilters": "Effacer les filtres",
    "noResults": "Aucun exercice ne correspond à ces filtres.",
    "tags": "Tags",
    "tagsHelp": "Étiquettes libres pour filtres et rapports. Tape un slug et Entrée, ou clique Suggérer pour repartir des champs structurés.",
    "tagsPlaceholder": "p. ex. compound, warmup, for-sandrine",
    "addTag": "Ajouter",
    "removeTag": "Retirer le tag",
    "suggestTags": "Suggérer",
    "description": "Description",
    "descriptionHelp": "Note courte affichée dans le catalogue et comme indice dans le logger. Les autres langues sont remplies automatiquement.",
    "descriptionPlaceholder": "Mise en place, point clé, erreur fréquente…",
    "descriptionResetDefault": "Réinitialiser à la valeur par défaut",
    "locale_en": "EN",
    "locale_it": "IT",
    "locale_fr": "FR",
    "locale_de": "DE",
    "locale_ru": "RU",
    "equipment_treadmill": "Tapis de course",
    "equipment_exercise-bike": "Vélo d'appartement",
    "equipment_elliptical": "Vélo elliptique",
    "equipment_rower": "Rameur",
    "equipment_stair-climber": "Escalier mécanique",
    "equipment_jump-rope": "Corde à sauter",
    "equipment_battle-ropes": "Cordes ondulatoires",
    "equipment_sled": "Traîneau",
    "deletedExercise": "Exercice supprimé"
  },
  "swap": {
    "title": "Remplacer l'exercice",
    "currentLabel": "Actuel",
    "searchPlaceholder": "Rechercher dans le catalogue…",
    "showAll": "Afficher tous les exercices",
    "noMatches": "Aucun exercice ne correspond à votre recherche.",
    "noSuggestions": "Aucun similaire trouvé via les tags. Cochez « Afficher tous » pour parcourir le catalogue.",
    "close": "Fermer",
    "reasonTags": "Tags communs ×{{count}}",
    "reasonPrimary": "Muscles communs ×{{count}}",
    "reasonDifferentEquipment": "Matériel différent",
    "suggestedSection": "Suggérés",
    "allSection": "Tous les exercices",
    "whichMachine": "Quelle machine ?",
    "defaultMachine": "Machine par défaut",
    "machineLabel": "Machine {{letter}}",
    "setMachine": "Définir la machine",
    "machineChoices": "Machines connues : {{count}}",
    "newMachine": "Nouvelle machine",
    "bandSession": "Séance",
    "bandCurrentExercise": "Cet exercice",
    "bandOtherExercises": "Passer à un autre exercice",
    "equipmentKey": "Matériel",
    "currentConsequence": "Les séries déjà enregistrées restent : seul le matériel sur lequel elles sont notées change.",
    "unavailableTitle": "Pas ici ?",
    "unavailableBody": "Coche le matériel de {{exercise}} qui n'est pas à {{place}}. Seul ce que tu coches est enregistré.",
    "unavailableConfirm": "Enregistrer",
    "unavailableOpen": "Matériel non disponible ici",
    "unavailableOpenHint": "Demande quel matériel de cet exercice manque.",
    "unavailableBadge": "Pas ici",
    "unavailableRestore": "À nouveau disponible ici",
    "unavailableErrorTitle": "Échec de l'enregistrement",
    "unavailableErrorBody": "Le matériel est toujours indiqué comme disponible ici.",
    "unavailableConfirmHint": "Coche au moins un élément pour enregistrer.",
    "pinDefaultMachine": "Toujours utiliser la machine par défaut ici",
    "pinMachine": "Toujours utiliser {{machine}} ici",
    "pinHint": "Fin des questions sur la machine, dans cette salle, pour cet exercice.",
    "pinErrorTitle": "Échec de l'enregistrement",
    "pinErrorBody": "La machine par défaut ici n'a pas changé.",
    "unpinDefaultMachine": "Ne plus toujours utiliser la machine par défaut ici",
    "unpinMachine": "Ne plus toujours utiliser {{machine}} ici",
    "pinnedFootnoteDefault": "Ici, la machine par défaut est toujours utilisée.",
    "pinnedFootnoteMachine": "Ici, {{machine}} est toujours utilisée.",
    "unpinHint": "Retour aux questions sur la machine, dans cette salle, pour cet exercice."
  },
  "tabs": {
    "workout": "Séance",
    "plan": "Programme",
    "progress": "Progrès",
    "profile": "Profil",
    "catalog": "Catalogue",
    "admin": "Admin",
    "workoutEyebrow": "Séance du jour",
    "planEyebrow": "Programmation",
    "progressEyebrow": "Graphiques et rapports",
    "profileEyebrow": "Compte et maxis",
    "catalogEyebrow": "Catalogue des exercices",
    "adminEyebrow": "Console admin",
    "progressEmpty": "Enregistrez d'abord une séance — les graphiques apparaissent quand il y a des données."
  },
  "shell": {
    "navAria": "Navigation principale"
  },
  "theme": {
    "aria": "Thème",
    "light": "Clair",
    "dark": "Sombre",
    "auto": "Auto"
  },
  "import": {
    "title": "Importer des séances depuis un CSV",
    "help": "Charge un export d'un autre tracker. Tu confirmes que tu es propriétaire des données et que ce qui sera importé dans JackedLogs reste sous ta responsabilité. Les séances déjà importées sont détectées par id et ignorées.",
    "sourceLabel": "Plateforme source",
    "source": {
      "strengthlog": "StrengthLog"
    },
    "sourceHint": {
      "strengthlog": "Depuis StrengthLog : ouvre Réglages, puis Export, choisis Logs full export. Sauvegarde le CSV où tu veux et sélectionne-le ci-dessous. Le nom du fichier d'origine n'a pas d'importance."
    },
    "languageDisclaimer": "Les noms d'exercices sont comparés en anglais. Les noms dans d'autres langues seront créés comme exercices brouillons, à renommer à la main dans le catalogue.",
    "consent": "J'ai exporté ce fichier depuis mon propre compte et je suis propriétaire des données.",
    "fileLabel": "Fichier CSV",
    "parsing": "Lecture du fichier…",
    "cancel": "Annuler",
    "confirm": "Lancer l'import",
    "again": "Importer un autre fichier",
    "done": "Import terminé",
    "seedMaxesPrompt": "Tu veux initialiser tes MAX à partir des entraînements importés ? L'onglet Profil propose une suggestion en un clic basée sur chaque série que tu viens d'importer.",
    "seedMaxesGo": "Initialiser les MAX depuis l'historique",
    "summary": {
      "rows": "{{count}} lignes",
      "sessions": "{{count}} séances",
      "exercises": "{{count}} exercices",
      "dateRange": "du {{from}} au {{to}}",
      "autoMatched": "{{count}} correspondent au catalogue",
      "draftsToCreate": "{{count}} exercices seront créés comme brouillons",
      "unparseable": "{{count}} noms ne donnent pas de slug et seront ignorés",
      "unparseableShow": "Afficher les noms"
    },
    "draftsCallout": "Les brouillons portent le flag auto_imported. Ils sont utilisables tout de suite pour logger. Un athlète ou un coach pourra ensuite les revoir et les promouvoir, ajouter muscles et équipement, ou fusionner les doublons.",
    "draftsProgress": "Création des brouillons : {{done}} / {{total}}",
    "mappingsTitle": "Correspondance des exercices",
    "mappingsStats": "{{matched}} associés automatiquement · {{pending}} à résoudre · {{resolved}} résolus · {{skipped}} ignorés",
    "allResolved": "Tous les exercices sont résolus. Tu peux lancer l'import.",
    "confidenceHint": "Plus proche : {{top}} ({{pct}}%)",
    "toggle": {
      "showResolved": "Afficher les résolus ({{count}})",
      "hideResolved": "Masquer les résolus",
      "showMatched": "Afficher les associés automatiquement ({{count}})",
      "hideMatched": "Masquer les associés automatiquement"
    },
    "action": {
      "create": "Créer comme nouvel exercice",
      "pickExisting": "Utiliser un existant",
      "skip": "Ignorer"
    },
    "create": {
      "name": "Nom de l'exercice",
      "bodyweight": "Exercice au poids du corps (sans charge externe)",
      "submit": "Créer",
      "submitting": "Création…"
    },
    "pick": {
      "label": "Exercice du catalogue",
      "placeholder": "Choisis-en un…",
      "rememberAlias": "Garder \"{{csvName}}\" comme alias pour les prochains imports",
      "submit": "Confirmer",
      "submitting": "Enregistrement…"
    },
    "skip": {
      "help": "Les séries de cet exercice ne seront pas importées. Tu peux changer d'avis ci-dessous.",
      "submit": "Confirmer l'ignorance"
    },
    "resolved": {
      "auto": "→ {{name}} (auto)",
      "linked": "→ {{name}} (associé)",
      "linkedAlias": "→ {{name}} (associé, alias enregistré)",
      "created": "→ {{name}} (créé)",
      "skipped": "ignoré",
      "undo": "Annuler"
    },
    "mapping": {
      "suggestions": "Suggestions",
      "allCatalog": "Tout le catalogue"
    },
    "progress": {
      "label": "{{done}} / {{total}} ({{pct}}%)",
      "tally": "Créés {{created}} · Déjà importés {{duplicates}} · Échecs {{failed}}"
    },
    "report": {
      "created": "Séances créées : {{count}}",
      "duplicates": "Déjà importées : {{count}}",
      "draftsCreated": "Brouillons créés : {{count}}",
      "invalid": "Données invalides : {{count}}",
      "unknownExercise": "Exercice inconnu : {{count}}",
      "failed": "Échecs : {{count}}",
      "detailsToggle": "Afficher les échecs",
      "moreFailures": "et {{more}} autres"
    },
    "errors": {
      "catalogNotReady": "Le catalogue d'exercices est encore en chargement. Attends un instant puis sélectionne le fichier à nouveau.",
      "emptyFile": "Aucune ligne dans le fichier.",
      "missingColumns": "Colonnes requises manquantes : {{columns}}.",
      "parseFailed": "Lecture du fichier impossible.",
      "nothingToImport": "Rien à importer après la création des brouillons. Vérifie le fichier.",
      "draftsFailed": "Impossible de créer les brouillons : {{message}}"
    }
  },
  "mobile": {
    "bodymap": {
      "muscle": {
        "chest": "Pectoraux",
        "biceps": "Biceps",
        "triceps": "Triceps",
        "forearm": "Avant-bras",
        "front-deltoids": "Épaules",
        "back-deltoids": "Deltoïdes arrière",
        "trapezius": "Trapèzes",
        "upper-back": "Dos",
        "lower-back": "Bas du dos",
        "abs": "Tronc",
        "obliques": "Tronc",
        "quadriceps": "Quadriceps",
        "hamstring": "Ischio-jambiers",
        "gluteal": "Fessiers",
        "adductors": "Adducteurs",
        "abductors": "Abducteurs",
        "calves": "Mollets",
        "tibialis": "Tibial",
        "neck": "Cou",
        "head": "Tête"
      }
    },
    "tabs": {
      "workouts": "Entraînements",
      "plan": "Accueil",
      "progress": "Progression",
      "catalog": "Catalogue",
      "profile": "Profil",
      "settings": "Réglages",
      "inbox": "Boîte",
      "athletes": "Athlètes",
      "me": "Moi"
    },
    "me": {
      "sectionTraining": "Entraînement",
      "navTargets": "Objectifs",
      "navTargetsSub": "Vos objectifs hebdomadaires"
    },
    "settings": {
      "title": "Réglages",
      "exercisesSection": "Exercices",
      "navExercisesSub": "MAX, catalogue, échelle d'effort",
      "navCatalog": "Catalogue d'exercices",
      "selectPrompt": "Sélectionne un réglage pour l'ouvrir.",
      "navCatalogSub": "Parcourez la bibliothèque d'exercices",
      "navEffort": "Réglages d'effort",
      "navEffortSub": "Échelle RIR / RPE + légende",
      "navLicenses": "Licences open source",
      "navLicensesSub": "Les bibliothèques qui font tourner l'app",
      "sectionAccount": "Compte",
      "sectionTraining": "Entraînement",
      "sectionBody": "Corps",
      "sectionPrefs": "Préférences",
      "sectionCoach": "Coach",
      "sectionAbout": "À propos",
      "sectionHealthConnect": "Health Connect",
      "navHealthConnect": "Health Connect",
      "navHealthConnectSub": "Synchronisez entraînements et données de santé depuis votre appareil"
    },
    "energySource": {
      "zepp": "Zepp",
      "googleFit": "Google Fit",
      "healthConnect": "Health Connect",
      "jlEstimate": "JackedLogs",
      "pillLabel": "Sources des calories",
      "projectionNote": "Inclut la série que tu vas faire : une projection de toute la séance, pas le travail déjà enregistré.",
      "selected": "sélectionnée"
    },
    "hc": {
      "preferences": "Préférences",
      "caloriesWins": "Health Connect prime sur les calories",
      "caloriesWinsHelp": "Quand les deux existent, affiche les calories mesurées via Health Connect plutôt que l'estimation de JackedLogs. Désactivé = préférer l'estimation. Sans valeur Health Connect, l'estimation est toujours utilisée.",
      "title": "Health Connect",
      "intro": "Importez l'activité de votre montre et de votre téléphone dans JackedLogs. Marches, randonnées et sorties à vélo deviennent des séances ; fréquence cardiaque et calories enrichissent les séances que vous enregistrez. Désactivé tant que vous ne connectez pas.",
      "checking": "Vérification…",
      "unavailable": "Health Connect n'est pas disponible sur cet appareil.",
      "updateRequired": "Mettez à jour l'application Health Connect pour continuer.",
      "notConnected": "Non connecté.",
      "connect": "Connecter Health Connect",
      "connectHelp": "Vous choisissez les données que JackedLogs peut lire. Modifiable à tout moment dans Health Connect.",
      "connected": "Connecté",
      "reads": "Lit les séances, la fréquence cardiaque et les calories.",
      "syncNow": "Synchroniser",
      "neverSynced": "Pas encore synchronisé.",
      "lastSyncedAt": "Dernière synchro : {{when}}",
      "syncDelayNote": "Une nouvelle activité peut mettre quelques minutes à arriver dans Health Connect depuis votre appareil : une marche ou une sortie vélo récente peut n'apparaître qu'à une synchro ultérieure. Ce délai est normal.",
      "syncFullHistory": "Synchroniser tout l'historique",
      "syncingFullHistory": "Synchronisation de l'historique en cours",
      "syncFullHistoryHelp": "Revérifie tout ton historique et comble les manques dans Health Connect. À utiliser si une correction passée y manque. Peut se relancer sans risque.",
      "resultSummary": "{{imported}} importées · {{enriched}} enrichies · {{skipped}} ignorées",
      "error": "Une erreur s'est produite. Veuillez réessayer.",
      "manageInHc": "Gérer dans Health Connect",
      "disconnect": "Déconnecter",
      "disconnectTitle": "Déconnecter Health Connect ?",
      "disconnectBody": "JackedLogs cessera de lire vos données Health Connect. Les séances déjà importées restent dans votre historique.",
      "logoA11y": "Health Connect",
      "privacyTitle": "Vos données",
      "privacyBody": "JackedLogs ne lit que ce que vous autorisez dans Health Connect, et uniquement sur ce téléphone après connexion. Elles sont stockées dans votre compte JackedLogs privé, jamais partagées ni vendues. Déconnectez-vous à tout moment pour arrêter.",
      "bodyResult": "{{imported}} corporelles importées · {{skipped}} ignorées",
      "bodyNotGranted": "Données corporelles pas encore autorisées. Touchez Autoriser les données corporelles.",
      "readsFull": "Lit les séances, la fréquence cardiaque et les calories, le poids et la composition corporelle, la glycémie et la nutrition. Écrit la glycémie dans Health Connect.",
      "backfillTitle": "Importer l'historique depuis mai ?",
      "backfillBody": "Parcourt ton historique Health Connect jusqu'à mai et importe ce qui manque. Tu peux le relancer sans risque: les éléments déjà importés sont ignorés.",
      "backfillNow": "Importer l'historique",
      "grantExtra": "Autoriser les données santé",
      "extraGrantBody": "Importe aussi le poids, la composition corporelle, la glycémie et la nutrition.",
      "metabolicResult": "{{glucose}} glycémie · {{nutrition}} nutrition importées",
      "metabolicNotGranted": "Glycémie et nutrition pas encore autorisées.",
      "writeGlucoseGrantBody": "Autoriser JackedLogs à écrire la glycémie dans Health Connect.",
      "grantWrite": "Autoriser l'écriture",
      "syncGlucoseToHc": "Écrire la glycémie dans Health Connect"
    },
    "metabolic": {
      "title": "Métabolique",
      "loading": "Chargement…",
      "empty": "Connecte Health Connect et synchronise pour voir ici la glycémie et la nutrition.",
      "glucoseEmpty": "Aucune valeur de glycémie",
      "glucoseLatest": "Dernière glycémie",
      "mgdl": "mg/dL",
      "targetBand": "Plage cible typique {{lo}}–{{hi}} {{unit}}.",
      "carbsToday": "Glucides aujourd'hui",
      "grams": "g",
      "glucoseTitle": "Glycémie",
      "glucoseCurrent": "Dernière : {{value}} {{unit}}",
      "glucoseNone": "Enregistre une valeur pour suivre ta glycémie."
    },
    "exercisesScreen": {
      "back": "Retour"
    },
    "body": {
      "back": "Retour",
      "title": "Corps",
      "navTitle": "Corps",
      "navSub": "Sexe, âge, silhouette, carte de la douleur",
      "trendsWebHint": "Les graphiques de composition corporelle sont dans l'app mobile.",
      "sexLabel": "Sexe",
      "sexHelp": "Utilisé uniquement pour l'estimation du taux de masse grasse. La silhouette de la carte musculaire est un choix distinct ci-dessous.",
      "sex_male": "Homme",
      "sex_female": "Femme",
      "measurementsTitle": "Mensurations",
      "measurementsSub": "Poids, circonférences, estimation de masse grasse",
      "measureTitle": "NOUVELLE MESURE",
      "weight": "Poids",
      "field_heightCm": "Taille",
      "field_neckCm": "Cou",
      "field_chestCm": "Poitrine",
      "field_waistCm": "Tour de taille",
      "field_hipsCm": "Hanches",
      "field_bicepsLCm": "Biceps (G)",
      "field_bicepsRCm": "Biceps (D)",
      "field_forearmsLCm": "Avant-bras (G)",
      "field_forearmsRCm": "Avant-bras (D)",
      "field_thighsLCm": "Cuisse (G)",
      "field_thighsRCm": "Cuisse (D)",
      "field_calvesLCm": "Mollet (G)",
      "field_calvesRCm": "Mollet (D)",
      "measureSave": "Enregistrer les valeurs saisies",
      "measureHelpC": "Remplis seulement ce que tu as mesuré. Les champs vides ne sont pas enregistrés.",
      "useLastA11y": "Utiliser la dernière valeur {{value}}",
      "saveFailedTitle": "Échec de l'enregistrement",
      "saveFailedBody": "Ta mesure n'a pas été enregistrée. Tes valeurs sont conservées — touche Enregistrer pour réessayer.",
      "editTitle": "MODIFIER — {{date}}",
      "saveChanges": "Enregistrer les modifications",
      "editCancelA11y": "Annuler la modification",
      "editRowA11y": "Modifier la mesure {{date}}",
      "editHelp": "Modifie une valeur, ou efface-la pour la retirer de l'historique.",
      "trendsLabel": "TENDANCES",
      "trendsHint": "choisir les mesures",
      "trendsExpandA11y": "Afficher toutes les mesures",
      "trendsCollapseA11y": "Réduire les mesures",
      "trendsEmpty": "Enregistre au moins 2 mesures pour voir une tendance.",
      "metricComposition": "Composition",
      "metricBodyFat": "Masse grasse",
      "metricLeanMass": "Masse maigre",
      "loadError": "Impossible de charger les mesures — vérifie ta connexion.",
      "queuedNote": "En attente de synchronisation : {{count}}",
      "navyTitle": "COMPOSITION CORPORELLE (NAVY)",
      "navyNeedsEntry": "Enregistrez une mesure ci-dessous pour estimer la masse grasse.",
      "navyNeedsSex": "Définissez votre sexe ci-dessus pour estimer la masse grasse.",
      "navyNeedsInputs": "Ajoutez taille, cou et tour de taille (et hanches, pour la formule féminine) pour estimer la masse grasse.",
      "navyBodyFat": "Masse grasse ≈ {{pct}} %",
      "navyLeanMass": "Masse maigre ≈ {{mass}}",
      "navyDisclaimer": "Estimation US Navy (~±3,5 %). Observez la tendance, pas le chiffre isolé.",
      "historyEmpty": "Aucune mesure pour l'instant. Enregistrez-en une ci-dessus pour commencer le suivi.",
      "historyTitle": "HISTORIQUE",
      "trendWeight": "TENDANCE DU POIDS",
      "trendBodyFat": "TENDANCE MASSE GRASSE",
      "deleteTitle": "Supprimer la mesure ?",
      "deleteEmptyTitle": "Retirer cette mesure ?",
      "deleteEmptyBody": "Toutes ses valeurs sont effacées, l'entrée sera donc supprimée.",
      "deleteCancel": "Annuler",
      "deleteConfirm": "Supprimer",
      "ageLabel": "Âge",
      "ageHelp": "Facultatif. Touche à nouveau pour effacer.",
      "dualCurveLegend": "Plein : estimation · Tirets : Health Connect",
      "bodyFatProvenance": "La masse grasse se calcule à partir de la taille et du cou.",
      "bodyFatProvenanceWithHips": "La masse grasse se calcule à partir de la taille, du cou et des hanches."
    },
    "effortSettings": {
      "back": "Retour",
      "title": "Effort",
      "scaleLabel": "Échelle d'effort",
      "scaleHelp": "L'échelle utilisée par le Logger. RIR = répétitions encore en réserve ; RPE = effort perçu. RPE = 10 − RIR, c'est donc le même effort sur deux échelles."
    },
    "plan": {
      "currentBlockError": "Impossible de définir le bloc actuel. Réessaie.",
      "currentBlockOn": "Bloc actuel — appuie pour retirer",
      "currentBlockOff": "Définir comme bloc actuel",
      "currentBlockHint": "Épingle les objectifs hebdomadaires de ce programme au compteur de l'accueil",
      "title": "Plan",
      "start": "Démarrer",
      "starting": "Ouverture…",
      "programWeekSession": "Semaine {{week}}/{{cycle}} · {{session}}",
      "programLastCompleted": "Dernière : S{{week}} · {{session}}",
      "programNextHeader": "À suivre",
      "programStartCta": "▶ Démarrer {{session}}",
      "programChangeLink": "Changer semaine ou séance ›",
      "carouselPosition": "Programme {{n}} sur {{total}}",
      "carouselPrev": "Programme précédent",
      "carouselNext": "Programme suivant",
      "programWeekLabel": "Semaine",
      "singleCycle": "Cycle unique, identique chaque semaine",
      "programSessionLabel": "Séance",
      "programWeekShort": "S{{n}}",
      "programDayShort": "J{{n}}",
      "sessionN": "Séance {{n}}",
      "sessionNShort": "S{{n}}",
      "programConfirm": "Démarrer S{{week}} · {{session}}",
      "cancel": "Annuler",
      "newWorkout": "Nouvel entraînement",
      "programsHint": "Cycles multi-semaines qui avancent automatiquement quand tu enregistres les séances.",
      "planDeleteTitle": "Supprimer le plan ?",
      "programDeleteTitle": "Supprimer le programme ?",
      "programStatusError": "Impossible de mettre à jour le programme. Réessayez.",
      "view": "Voir",
      "hide": "Masquer",
      "programUnfollowHint": "Ne plus suivre ce programme (il reste dans Mes programmes)",
      "programNextInline": "Suivant : W{{week}} · {{session}}",
      "programStartA11y": "Démarrer {{session}}",
      "startPlanA11y": "Démarrer {{name}}"
    },
    "preview": {
      "muscles": "Muscles",
      "noSets": "Aucune série prévue",
      "alternates": "Alternatives : {{names}}",
      "gridTitle": "Intensité · jour × semaine",
      "gridHint": "Touchez un jour pour voir ses mouvements.",
      "matrixTitle": "Intensité · par série",
      "matrixHint": "Touchez un exercice pour voir ses séries.",
      "restDay": "Repos / léger",
      "intensity": {
        "work": "travail",
        "moderate": "modéré",
        "heavy": "lourd",
        "max": "Max",
        "free": "libre"
      }
    },
    "catalog": {
      "title": "Catalogue",
      "search": "Rechercher des exercices",
      "empty": "Aucun exercice ne correspond.",
      "back": "Retour",
      "notFound": "Exercice introuvable.",
      "metaPrimaryMuscle": "Muscle principal",
      "metaPattern": "Pattern",
      "metaEquipment": "Équipement",
      "metaP1RM": "Programmable",
      "metaP1RMYes": "Oui",
      "metaP1RMNo": "Non",
      "metaDefaultBar": "Barre par défaut",
      "metaBarLoading": "Chargement de la barre",
      "metaBarLoadingLandmine": "Landmine (extrémité unique)",
      "aliasesLabel": "Aussi appelé",
      "tagsLabel": "Tags",
      "historyLabel": "Séances récentes",
      "historyEmpty": "Aucune séance passée pour cet exercice.",
      "historyError": "Impossible de charger l'historique.",
      "historyBodyweight": "{{reps}} reps au poids du corps",
      "recordsLabel": "Records",
      "recordsEmpty": "Pas encore de record.",
      "selectPrompt": "Sélectionnez un exercice pour voir ses détails.",
      "recordsError": "Impossible de charger les records.",
      "refreshing": "Mise à jour…"
    },
    "maxes": {
      "title": "MAX",
      "back": "Retour",
      "search": "Rechercher des exercices",
      "empty": "Aucun exercice ne correspond.",
      "editCancel": "Annuler",
      "editSave": "Enregistrer",
      "errInvalid": "Saisis un poids valide.",
      "clearAction": "Retirer le MAX",
      "clearTitle": "Retirer ce MAX ?",
      "clearBody": "La valeur et l'historique restent sur le serveur, mais le MAX sera marqué comme non défini.",
      "clearCancel": "Annuler",
      "clearConfirm": "Retirer",
      "selectPrompt": "Sélectionne un exercice pour définir son MAX.",
      "unitChipLabel": "Unité de poids : {{unit}}",
      "unitKg": "kilogrammes",
      "unitLb": "livres",
      "unitChipHint": "Change l'unité et convertit la valeur"
    },
    "login": {
      "title": "JackedLogs",
      "subtitle": "Connexion à ton compte",
      "submit": "Se connecter"
    },
    "workouts": {
      "title": "Entraînements",
      "empty": "Aucun entraînement enregistré.",
      "fallbackName": "Entraînement",
      "endOfList_one": "{{count}} séance, fin de la liste.",
      "endOfList_other": "{{count}} séances, fin de la liste.",
      "newButton": "Nouveau",
      "queuedBanner_one": "{{count}} entraînement en attente. Touche pour réessayer.",
      "queuedBanner_other": "{{count}} entraînements en attente. Touche pour réessayer.",
      "maxQueuedBanner_one": "{{count}} MAX en attente. L'envoi se fera tout seul au retour du réseau.",
      "maxQueuedBanner_other": "{{count}} MAX en attente. L'envoi se fera tout seul au retour du réseau.",
      "maxQueuedHint": "Touche pour synchroniser maintenant.",
      "maxConfirmFailedTitle": "MAX non enregistré",
      "maxConfirmFailedBody": "Le serveur n'a pas accepté cette valeur, donc rien n'a été écrit. Ton MAX reste inchangé. Tu peux le régler à la main depuis Moi, Maxima.",
      "queuedRetry": "Réessayer",
      "queuedDetail": "Détails",
      "queuedHint": "Touche pour réessayer, appui long pour abandonner.",
      "queuedHintDetail": "Touche pour voir la file, appui long pour abandonner.",
      "queueDismissTitle": "Abandonner les entraînements en file ?",
      "queueDismissBody_one": "{{count}} entraînement sera supprimé et non enregistré.",
      "queueDismissBody_other": "{{count}} entraînements seront supprimés et non enregistrés.",
      "queueDismissCancel": "Annuler",
      "queueDismissConfirm": "Abandonner",
      "editUnsupportedTitle": "Modification non encore disponible sur mobile",
      "editUnsupportedBody": "Cet entraînement contient des types d'exercices (P1RM, loaded carry) que le logger mobile ne sait pas encore modifier. Ouvre-le dans l'app web.",
      "editUnsupportedAck": "OK",
      "maxBumpHeader_one": "{{count}} nouveau MAX",
      "maxBumpHeader_other": "{{count}} nouveaux MAX",
      "maxBumpRow": "{{exercise}} : {{valueKg}} kg",
      "maxBumpConfirm": "Confirmer",
      "maxBumpDismiss": "Passer",
      "repeat": "Répéter l'entraînement",
      "resumePillAction": "Reprendre",
      "resumePillFallback": "Entraînement en cours",
      "cancel": "Annuler",
      "loadOlder": "Charger les mois précédents",
      "selectPrompt": "Sélectionne un entraînement pour voir son résumé.",
      "loadError": "Impossible de charger cette séance.",
      "maxDropRow": "{{exercise}} : le MAX a peut-être baissé à {{valueKg}} kg (était {{currentKg}}, il y a {{weeks}} sem.)",
      "maxDropConfirm": "Baisser à {{valueKg}}",
      "maxDropKeep": "Garder {{valueKg}}",
      "maxDropBadDay": "Mauvais jour",
      "importedBadge": "Importé"
    },
    "outboxDetail": {
      "title": "Entraînements en file",
      "close": "Fermer",
      "empty": "Rien en file.",
      "statusQueued": "En file",
      "statusSending": "Envoi en cours",
      "statusFailed4xx": "Le serveur a refusé",
      "statusPermanentFail": "J'ai renoncé",
      "attempts_one": "{{count}} tentative",
      "attempts_other": "{{count}} tentatives",
      "dismissOne": "Abandonner",
      "dismissOneTitle": "Abandonner cet entraînement ?",
      "dismissOneBody": "L'entraînement du {{date}} sera supprimé sans être enregistré.",
      "dismissCancel": "Annuler",
      "dismissConfirm": "Abandonner",
      "retryAll": "Tout réessayer",
      "dismissAll": "Tout abandonner",
      "queueWorkout": "Séance",
      "queueWorkoutNote": "Note de séance",
      "queueMeasurement": "Mesure",
      "queueMax": "Maximum",
      "queueProfile": "Profil",
      "queueHealth": "Données santé",
      "queueMetabolic": "Données métaboliques",
      "queueRequest": "Modification",
      "stuckTitle": "Enregistrements non passés"
    },
    "stuckWrites": {
      "banner_one": "{{count}} enregistrement n'est pas passé",
      "banner_other": "{{count}} enregistrements ne sont pas passés",
      "retry": "Réessayer",
      "retrying": "Nouvel essai…",
      "details": "Détails"
    },
    "progress": {
      "title": "Progression",
      "windowAll": "Séances récentes",
      "window30d": "30 derniers jours",
      "window7d": "7 derniers jours",
      "lastSession": "Dernière séance",
      "frequencyTitle": "Fréquence hebdomadaire",
      "frequencyHelp": "Séances par semaine, {{weeks}} dernières semaines (semaine en cours à droite).",
      "recordsTitle": "Records",
      "recordsHelp": "Meilleurs records par répétition par exercice. Plus récents en premier.",
      "recordsAllTime": "Tout temps",
      "recordsThisYear": "{{year}}",
      "recordsSearch": "Filtrer par exercice",
      "recordsNoMatch": "Aucun exercice ne correspond au filtre.",
      "tagVolumeTitle": "Volume par tag",
      "tagVolumeHelp": "Volume d'entraînement par muscle/tag sur la période récente.",
      "recordsEmpty": "Aucun record — enregistre quelques séries pour démarrer.",
      "chartE1rm": "1RM estimé",
      "chartVolume": "Volume",
      "chartScope": "Basé sur les {{n}} dernières séances.",
      "chartLoadFailed": "Impossible de charger le graphique.",
      "chartEmpty": "Aucune série avec poids sur la fenêtre récente.",
      "viewByExercise": "Par exercice",
      "viewByTag": "Par tag",
      "noTags": "Aucun exercice avec tags sur la fenêtre récente.",
      "totalVolume": "Total : {{weight}}",
      "chartMax": "MAX (kg)",
      "chartEstimatedBadge": "avec aperçu e1RM",
      "prFound": "Record trouvé : {{weight}}",
      "prUpdate": "Mettre à jour le MAX à {{weight}}",
      "prUpdating": "Mise à jour…",
      "painSeverity": {
        "red": "rouge",
        "yellow": "jaune",
        "green": "vert"
      },
      "balance": {
        "title": "Équilibre des mouvements",
        "help": "Séries et volume par schéma de mouvement sur la fenêtre sélectionnée de {{days}} jours, triés par séries. Le petit chiffre « X/7 j » correspond au décompte des 7 derniers jours, utile pour repérer une poussée récente isolée (ou une baisse délibérée) que la fenêtre plus longue masque."
      },
      "empty": "Aucune activité récente à comparer",
      "pain": {
        "title": "Douleur × volume",
        "help": "Pour chaque muscle actuellement signalé dans votre painMap, affiche la charge d’entraînement récente. Point rouge = douleur signalée rouge (évitez les charges lourdes), jaune = prudence, vert = à surveiller. Les deux chiffres de volume correspondent à la charge sur 7 jours vs la fenêtre sélectionnée de {{days}} jours pour ce muscle — une charge lourde soutenue sur un muscle rouge est le signal le plus à risque du tableau de bord.",
        "noPain": "Aucun muscle signalé dans painMap",
        "sevRed": "Éviter",
        "sevYellow": "Prudence",
        "sevGreen": "Surveiller"
      },
      "trends": {
        "a11yUp": "progression",
        "a11yFlat": "plateau",
        "a11yDown": "régression",
        "title": "Tendances E1RM",
        "help": "Pour chaque schéma de mouvement (squat, hinge, push, pull, …), affiche l’exercice où votre meilleur e1RM est le plus élevé. Graphique = points e1RM sur la fenêtre sélectionnée de {{days}} jours (touchez un point pour la valeur). Flèche = tendance sur cette fenêtre : ↗ progression, → plateau, ↘ régression. Le badge « Peu de données » apparaît lorsqu’il y a moins de 3 points pour ajuster une droite.",
        "fewData": "Trop peu de données sur {{days}} j",
        "notMeasurable": "Pas encore mesurable : aucune de vos séries de {{name}} n'est allée près de la limite. Une série menée proche de l'échec (un AMRAP) montrerait votre force ici.",
        "machineNotMeasurable": "{{value}}, pas encore mesurable",
        "machineMore": "{{machine}} · +{{count}}",
        "machineA11y_one": "{{exercise}}, {{machine}}. Afficher l'autre machine.",
        "machineA11y_other": "{{exercise}}, {{machine}}. Afficher les {{count}} autres machines.",
        "machineSessions_one": "{{count}} séance",
        "machineSessions_other": "{{count}} séances"
      },
      "repsAtLoad": {
        "a11yUp": "en hausse",
        "a11yFlat": "stable",
        "a11yDown": "en baisse",
        "title": "Répétitions à charge fixe",
        "help": "Pour les exercices où vous répétez la même charge, ceci suit les répétitions à ce poids fixe sur la fenêtre de {{days}} jours — le gain de force que le graphique e1RM ne voit pas sur le haut-répétitions et les machines. Graphique = répétitions à la charge dans le temps (touchez un point). Flèche = tendance : ↗ en hausse, → stable, ↘ en baisse. Seules les séries avec l'effort renseigné comptent, ainsi plus de répétitions ne peut pas vouloir dire juste un jour plus facile.",
        "repsValue": "{{reps}} × {{load}}",
        "fewData": "Trop peu de données sur {{days}} j",
        "notMeasurable": "Pas encore mesurable : vos séries de {{name}} à {{load}} n'ont pas l'effort renseigné, donc plus de répétitions pourraient vouloir dire juste un jour plus facile. Une série menée près de l'échec — ou l'effort renseigné — montrerait votre force ici."
      },
      "period": {
        "all": "tout"
      },
      "loadFailed": "Impossible de charger",
      "density": {
        "title": "Densité",
        "help": "Volume divisé par la durée de la séance, kg/min. Se lit comme « à quel point cette séance était dense » — quand ça monte, vous travaillez la même charge en moins de temps (meilleur conditionnement) ou plus de charge dans le même temps (meilleure force). Une chute soudaine sans changement du programme indique souvent de la fatigue : les pauses se sont allongées même sans intention.",
        "empty": "Au moins 3 séances chronométrées pour tracer la densité"
      },
      "frequency": {
        "title": "Exercices les plus négligés",
        "help": "Top 8 des exercices triés par jours depuis la dernière séance, les plus négligés en premier. Le suffixe X/{{days}} j correspond au nombre de séries sur la fenêtre sélectionnée. Chiffres en rouge = 14 j ou plus sans toucher : soit vous l’avez retiré intentionnellement, soit le programme a dérivé. Utile pour repérer un travail accessoire qui a discrètement disparu.",
        "today": "aujourd’hui",
        "daysAgo": "il y a {{n}} j"
      },
      "fatigueDrift": {
        "title": "Dérive de fatigue (RIR)",
        "help": "Moyenne hebdomadaire glissante du RPE et des reps en réserve sur les séries où les deux sont enregistrés. RPE qui monte et RIR qui descend sur des charges similaires = fatigue accumulée visible avant que la barre ralentisse. Une semaine de décharge résout généralement la situation.",
        "noData": "Enregistre le RPE et le RIR sur quelques séries pour tracer la dérive de fatigue",
        "rising": "Fatigue en hausse",
        "stable": "Stable",
        "legend": "RPE (gauche) · RIR (droite) — touchez une semaine pour les valeurs"
      },
      "intensityHeatmap": {
        "title": "Carte d'intensité",
        "help": "Grille par exercice des séries effectuées, classées par plage de répétitions et par intensité (% du 1RM). Plage de force (85%+) en bas à droite, hypertrophie au centre, endurance en haut à gauche. Choisis un exercice pour voir où se concentrent ses séries.",
        "exerciseLabel": "Exercice",
        "choosePrompt": "Choisis un exercice",
        "noEligible": "Enregistre un 1RM sur au moins un exercice pour calculer l'intensité.",
        "noMax": "Aucun 1RM enregistré pour cet exercice.",
        "totalSets": "{{n}} séries · 1RM {{max}}",
        "clear": "Aucun"
      },
      "a11y": {
        "severityAlarm": "Alarme",
        "severityWarn": "Avertissement",
        "severityInfo": "Info",
        "stale": "Inactif"
      }
    },
    "profile": {
      "title": "Profil",
      "navMaxes": "MAX",
      "navMaxesSub": "Définis, modifie et révise tes MAX par exercice.",
      "navCatalogSub": "Parcourez les exercices, records et historique.",
      "navRestTimer": "Minuteurs",
      "navRestTimerSub": "Réglages repos + maintien, son, par exercice",
      "labelEmail": "E-MAIL",
      "labelApp": "VERSION APP",
      "labelBackend": "VERSION BACKEND",
      "labelPrivacy": "CONFIDENTIALITÉ",
      "privacyHelp": "Exporte tout en JSON ou supprime le compte définitivement.",
      "exportButton": "Exporter mes données",
      "deleteButton": "Supprimer mon compte",
      "deleteAlertTitle": "Supprimer le compte",
      "deleteAlertBody": "Ton compte, tes séances, tes plans, tes programmes et tes MAX seront supprimés définitivement. Les suppressions ne se récupèrent pas.",
      "deleteAlertCancel": "Annuler",
      "deleteAlertConfirm": "Supprimer",
      "signOut": "Se déconnecter",
      "exportShareTitle": "Export JackedLogs {{date}}",
      "labelLanguage": "Langue",
      "languageHelp": "Choisis la langue utilisée dans l'app. Enregistrée sur cet appareil.",
      "languageCancel": "Fermer"
    },
    "summary": {
      "prBadge": "record personnel"
    },
    "logger": {
      "title": "Nouvel entraînement",
      "cancel": "Annuler",
      "swapKindTitle": "Changer de type d'exercice ?",
      "swapKindBody": "Cet exercice se journalise différemment ; les séries déjà enregistrées ici seront effacées.",
      "swapKindConfirm": "Changer et effacer",
      "failConfirmTitle": "Reps valides",
      "failConfirmBody_one": "J'enregistre {{count}} rep propre. Celle ratée ne compte pas.",
      "failConfirmBody_other": "J'enregistre {{count}} reps propres. Celle ratée ne compte pas.",
      "failConfirmHint": "Corrige si tu en as fait plus ou moins.",
      "failConfirmStepDown": "Une rep propre de moins",
      "failConfirmStepUp": "Une rep propre de plus",
      "failConfirmSave": "Enregistrer",
      "amrapConfirmTitle": "Jusqu'à l'échec ?",
      "amrapConfirmBody": "Réponds oui seulement si la répétition suivante ne serait pas passée.",
      "amrapNeedsReps": "Écris les répétitions que tu as faites pour enregistrer la série.",
      "amrapBadgeWithFloor": "AMRAP ≥ {{reps}}",
      "amrapPrescribedFloorA11y": "AMRAP : au moins {{reps}} répétitions, puis autant que possible",
      "amrapConfirmAtFloor": "Tu as noté {{reps}}, et le programme en demandait au moins {{floor}}.",
      "amrapFloorPlaceholder": "≥ {{reps}}",
      "amrapConfirmYes": "Oui, jusqu'à l'échec",
      "amrapConfirmNo": "Non, il m'en restait",
      "failBadge": "Ratée",
      "failBadgeA11y": "série ratée",
      "save": "Enregistrer",
      "remove": "Retirer",
      "replace": "Remplacer",
      "addExercise": "Ajouter un exercice",
      "addSet": "Ajouter une série",
      "addRound": "Ajouter un tour",
      "pickerTitle": "Choisir l'exercice",
      "pickerSearch": "Rechercher un exercice",
      "pickerEmpty": "Aucun exercice trouvé.",
      "pickerClearFilters": "Effacer les filtres",
      "pickerFilters": "Filtres",
      "pickerFiltersN": "Filtres ({{n}})",
      "empty": "Aucun exercice. Ajoutes-en un pour commencer.",
      "setReps": "REPS",
      "amrapPrescribedA11y": "AMRAP : au moins les répétitions prévues, puis autant que possible",
      "setWeight": "KG",
      "setWeightLb": "LB",
      "setWeightBothSidesA11y": "Poids d'un côté, les deux côtés comptés ({{unit}})",
      "setTypeWorking": "Normal",
      "setTypeDropset": "Dropset",
      "setTypeMyorep": "Myo-rep",
      "setCommentLabel": "Commentaire de la série",
      "unitLabel": "Unité",
      "discardTitle": "Abandonner l'entraînement ?",
      "discardBody": "Tu vas perdre les séries déjà saisies.",
      "discardCancel": "Continuer",
      "discardConfirm": "Abandonner",
      "errNoEntries": "Ajoute au moins un exercice.",
      "errNoSets": "Chaque exercice doit avoir au moins une série avec reps et poids.",
      "errInvalid": "L'entraînement ne peut pas être enregistré tel quel.",
      "errSaveFailed": "Enregistrement échoué. Touche réessayer sur le bandeau de file dès que tu es en ligne.",
      "setNumberHeader": "SÉRIE",
      "removeSetA11y": "Supprimer cette série",
      "serverErrorTitle": "LE SERVEUR A REJETÉ L'ENREGISTREMENT",
      "serverErrorHint": "Corrige l'entraînement et réessaie. Si le message n'est pas clair, partage-le avec ton coach.",
      "setExtra": "EXTRA",
      "bwPromptTitle": "Enregistre ton poids corporel",
      "bwPromptBody": "Les exercices au poids du corps ont besoin de ton poids pour calculer la charge et le volume. Renseigne-le dans Réglages → Corps.",
      "bwPromptCta": "Définir",
      "setWeightTip": "Poids soulevé par série. Change kg/lb avec la puce d'unité sur chaque ligne.",
      "setExtraTip": "Assistance ou charge ajoutée au poids du corps. Tape un moins (−) pour l'assistance élastique/machine (le champ devient ambre) ; ceinture/disque ajouté est positif.",
      "setWeightMixedTip": "Groupe mixte : charge barre/stack sur les lignes avec poids, ± extra sur les lignes au poids du corps (moins = assistance).",
      "editTitle": "Modifier l'entraînement",
      "planTitle": "Planifie",
      "programTitle": "Programme",
      "repeatTitle": "Répéter l'entraînement",
      "minimize": "Réduire l'entraînement",
      "closeWorkout": "Fermer l'entraînement",
      "saveWorkout": "Enregistrer l'entraînement",
      "bilateral": "Bilatéral",
      "unilateral": "Unilatéral",
      "plates": "Disques",
      "numInvalid": "Nombre invalide",
      "numRange": "{{label}} {{min}}–{{max}}",
      "setRpeHint": "Effort 1–10",
      "setNoteLabel": "Note",
      "setNotePlaceholder": "Repère, technique, ressenti…",
      "elapsedA11y": "Temps écoulé",
      "totalsSets_one": "{{count}} série",
      "totalsSets_other": "{{count}} séries",
      "totalsReps_one": "{{count}} rép",
      "totalsReps_other": "{{count}} réps",
      "totalsTitle": "Totaux de l'entraînement",
      "totalsVolume": "Volume",
      "totalsSetsShort": "Séries",
      "totalsRepsShort": "Réps",
      "totalsByMuscle": "Travail par muscle",
      "restRest": "Repos",
      "startRestManual": "Démarrer le repos",
      "restSkip": "Passer",
      "restWord": "Repos",
      "restAddStep": "+{{n}} secondes",
      "restSubtractStep": "−{{n}} secondes",
      "restRemainingA11y": "{{time}} de repos",
      "restLockedA11y": "Modifications verrouillées pendant le repos. Touchez « passer » pour modifier.",
      "restEditA11y": "Définir le repos par défaut pour cet exercice",
      "restEditTitle": "Repos par défaut",
      "restEditBody": "Enregistrer ce repos comme défaut pour {{name}}",
      "restEditSave": "Enregistrer",
      "restEditSaving": "Enregistrement…",
      "restEditError": "Impossible d'enregistrer le repos par défaut. Réessaie.",
      "restEditCancel": "Annuler",
      "restEditSaveAsGlobal": "Définir comme défaut global",
      "restStepMinus": "Diminuer de {{step}} secondes",
      "restStepPlus": "Augmenter de {{step}} secondes",
      "restPause": "Pause",
      "restResume": "Reprendre",
      "restExpiredTitle": "Repos terminé",
      "holdExpiredTitle": "Temps écoulé",
      "restExpiredBody": "On reprend.",
      "holdExpiredBody": "Touche la barre d'effort pour enregistrer la série.",
      "boutExpiredTitle": "Intervalle terminé",
      "boutExpiredBody": "Série enregistrée toute seule.",
      "boutAutoLoggedA11y": "Intervalle terminé, {{time}} enregistrées.",
      "workoutFgsTitle": "Entraînement en cours",
      "workoutFgsBodyNamed": "{{name}} · touchez pour reprendre",
      "workoutFgsBody": "Touchez pour reprendre la séance",
      "descriptionToggle": "Afficher / masquer la description",
      "notesToggle": "Notes du coach pour cette séance",
      "notesProgramLabel": "Programme",
      "notesWorkoutLabel": "Cette séance",
      "note": "Note",
      "rpeChip": "RPE",
      "historyChip": "Historique",
      "more": "Autres actions",
      "addGroup": "Grouper avec un autre exercice",
      "cardioDuration": "Durée",
      "cardioDurationPlaceholder": "Secondes",
      "cardioDistance": "Distance",
      "cardioWeight": "Charge",
      "cardioHr": "FC moy",
      "cardioCalories": "Calories",
      "cardioOptionalsShow": "Afficher les autres champs",
      "cardioOptionalsHide": "Masquer les autres champs",
      "dateEditor": "Date et durée",
      "dateLabel": "Date",
      "startTimeLabel": "Début",
      "endTimeLabel": "Fin",
      "durationLabel": "Durée",
      "historyToggle": "Historique",
      "historyCount_one": "{{count}} séance",
      "historyCount_other": "{{count}} séances",
      "historyBest": "Meilleure",
      "historyCopy": "Copier",
      "historyBodyweight": "{{reps}} reps PdC",
      "historyEstimateHeader": "Estimation à partir d'un exercice similaire",
      "historyEstimatedFrom": "De {{name}}",
      "historyNoEstimate": "Pas encore d'historique, ni d'exercice similaire pour estimer.",
      "copyDialogTitle": "Copier la séance",
      "copyDialogBody": "Remplacer les séries en attente ou les ajouter aux existantes ?",
      "copyOverwrite": "Remplacer",
      "copyAppend": "Ajouter",
      "resumeTitle": "Reprendre l'entraînement ?",
      "resumeBody": "Tu as commencé un entraînement le {{date}} qui n'a pas été enregistré. Reprendre ou abandonner ?",
      "resumeContinue": "Reprendre",
      "resumeDiscard": "Abandonner",
      "conflictTitle": "Entraînement en cours",
      "conflictBody": "Tu enregistres déjà un entraînement. Continue ou affiche-le pour l'enregistrer ou l'abandonner.",
      "nameLabel": "Nom du workout",
      "namePlaceholder": "Nom : ex. Push…",
      "editNameA11y": "Modifier le nom de la séance",
      "setStateA11y": "série {{index}} {{state}}",
      "rpePlaceholder": "RPE",
      "unitA11y": "unité {{unit}}",
      "stepperPositive": "ajouter",
      "stepperNegative": "soustraire",
      "historyCount": "{{n}} séances",
      "rirPlaceholder": "RIR",
      "effortMeterEasy": "Facile",
      "effortMeterHard": "Difficile",
      "effortWord": "Effort",
      "holdSlotDone": "FAIT",
      "holdSlotHeld": "TENU",
      "holdSlotDoneA11y": "{{time}} fait",
      "holdSlotFailedA11y": "{{time}}, échoué",
      "holdSlotHeldA11y": "{{time}} tenu",
      "effortMeterFail": "Fail",
      "effortMeterTargetWord": "objectif",
      "effortQuestionRir": "Reps en réserve ?",
      "effortQuestionRpe": "C'était dur ?",
      "effortQuestionHint": "Ouvre l'échelle d'effort — son fonctionnement et comment la changer",
      "effortMeterHintLog": "Enregistre aussi la série comme terminée",
      "effortMeterHintRunning": "Arrête le minuteur et enregistre la série",
      "effortMeterHintEdit": "Met à jour l'effort de cette série enregistrée",
      "effortMeterFailHintLog": "Enregistre la série comme échouée",
      "effortMeterFailHintEdit": "Bascule la série entre terminée et échouée",
      "effortMeterTapCta": "Touche pour enregistrer la série",
      "effortMeterStopCta": "Touche pour arrêter et enregistrer",
      "effortNudgeOptOut": "Désactiver le rappel",
      "effortNudgeOptOutHint": "Une confirmation vous est demandée. Réactivation possible dans les Réglages.",
      "effortNudgeOptOutConfirmTitle": "Désactiver ce rappel ?",
      "effortNudgeOptOutConfirmBody": "Réactivation possible à tout moment dans les réglages.",
      "effortNudgeOptOutConfirmButton": "Désactiver",
      "effortMeterAmrapDone": "Fait",
      "effortMeterAmrapHint": "Enregistre la série à l’échec — aucune répétition en réserve",
      "amrapChip": "Autant de répétitions que possible",
      "burnPlus": "Burn+",
      "burnPlusChip": "Technique d'intensité Burn+ (dropset / myo-rep)",
      "loadAxisTitle": "Ce qui détermine la charge",
      "timedChip": "Chronométré",
      "noteChip": "Note",
      "noteClose": "Terminé",
      "effortLegendA11y": "Aide sur l'échelle d'effort",
      "rirLegendTitle": "RIR : répétitions en réserve",
      "rirLegendBody": "0 = aucune répétition en réserve\n1 = 1 répétition en réserve\n2 = 2 répétitions\n3 = bonne marge\n4+ = facile / échauffement",
      "rpeLegendTitle": "RPE : effort perçu",
      "rpeLegendBody": "10 = aucune répétition en réserve\n9 = 1 répétition en réserve\n8 = 2 répétitions\n7 = bonne marge\n6 ou moins = facile / échauffement",
      "timerStartCountdown": "Démarrer le compte à rebours",
      "timerStartCountup": "Démarrer le chronomètre",
      "timerSettings": "Réglages du minuteur pour cet exercice",
      "holdHeaderHours": "h",
      "holdHeaderMinutes": "min",
      "holdHeaderSeconds": "s",
      "holdHours": "Heures",
      "holdMinutes": "Minutes",
      "holdSeconds": "Secondes",
      "holdSubTen": "-10 s",
      "holdAddTen": "+10 s",
      "holdCancel": "Annuler",
      "holdClockElapsedA11y": "{{time}} écoulées",
      "holdClockOvertimeA11y": "{{time}} au-delà de l'objectif",
      "holdClockPausedA11y": "{{label}}, en pause",
      "holdClockRemainingA11y": "{{time}} restantes",
      "holdFlip": "Changer de sens",
      "holdExtraWeight": "Extra",
      "lateralityTipUni": "UNI · enregistre un côté ; le volume compte les deux (×2).",
      "lateralityTipBi": "BI · charge bilatérale ; le volume compte une fois (×1).",
      "tabExercises": "Exercices",
      "tabSuperset": "Superset",
      "pickerAddN": "Ajouter {{n}}",
      "pickerAlreadyInWorkout": "Déjà dans cette séance",
      "pickerAlreadyInBlock": "Déjà dans ce bloc",
      "pickerPin": "Ajouter aux favoris",
      "pickerUnpin": "Retirer des favoris",
      "noteReadA11y": "Note de l'exercice — touche pour la lire en entier",
      "prescriptionReadA11y": "Consigne de la série — touche pour la lire en entier",
      "helpToggle": "Aide — touchez une puce pour savoir ce qu’elle fait",
      "tipAmrap": "Autant de répétitions que possible — menez cette série jusqu’à l’échec technique.",
      "tipBurnPlus": "Techniques d’intensité — révélez Dropset ou Myo-rep pour pousser la série au-delà de l’échec.",
      "helpBanner": "Mode aide — touchez une puce pour savoir ce qu’elle fait ; touchez ⓘ pour quitter.",
      "helpModeHint": "Mode aide activé — ceci explique au lieu de modifier le réglage.",
      "targetsMore": "+{{count}} de plus",
      "targetEyebrow": "Cible"
    },
    "coachBanner": {
      "a11y": "{{count}} invitations coach en attente",
      "one": "1 invitation coach en attente",
      "many": "{{count}} invitations coach en attente",
      "action": "Ouvrir"
    },
    "coachEdges": {
      "empty": "Aucune relation coach. Un coach peut t'inviter depuis l'app web."
    },
    "toxicDraft": {
      "banner": "Entraînement corrompu récupéré.",
      "viewJson": "Voir le JSON",
      "sendSupport": "Envoyer au support",
      "dismiss": "Abandonner",
      "close": "Fermer",
      "jsonTitle": "Entraînement en quarantaine",
      "supportPrefix": "Draft corrompu détecté automatiquement par le compteur de boot. JSON en quarantaine ci-dessous.",
      "sentTitle": "Envoi au support",
      "sentBody": "Données de récupération envoyées.",
      "sendError": "Échec de l'envoi. L'entraînement reste en quarantaine."
    },
    "recovery": {
      "banner": "Entraînement récupéré",
      "summary": "{{date}} · {{exercises}} exercices · {{done}}/{{total}} séries faites",
      "saveAsNew": "Enregistrer comme nouveau",
      "discard": "Supprimer",
      "title": "Entraînement récupéré",
      "openBody": "Cet entraînement a été interrompu puis récupéré. Vérifie les séries et touche Enregistrer pour le sauvegarder comme nouvel entraînement.",
      "open": "Ouvrir",
      "cancel": "Annuler",
      "liveBusy": "Tu as un entraînement en cours. Enregistre-le ou supprime-le avant de récupérer celui-ci.",
      "discardTitle": "Supprimer l'entraînement récupéré ?",
      "discardBody": "L'entraînement récupéré sera définitivement supprimé.",
      "discardConfirm": "Supprimer",
      "error": "Impossible de récupérer l'entraînement. Réessaie.",
      "merge": "Fusionner…",
      "mergeTitle": "Fusionner l'entraînement",
      "mergePrompt": "Choisis un entraînement du même jour où fusionner :",
      "noSameDay": "Aucun entraînement du même jour où fusionner. Utilise « Enregistrer comme nouveau ».",
      "nothingToMerge": "Aucune série terminée à fusionner. Utilise « Enregistrer comme nouveau »."
    },
    "group": {
      "title": "Grouper cet exercice",
      "close": "Fermer",
      "standalone": "Indépendant",
      "supersetSection": "SUPERSETS",
      "circuitSection": "CIRCUITS",
      "supersetN": "Superset {{n}}",
      "circuitN": "Circuit {{n}}",
      "newSuperset": "+ Nouveau superset",
      "newCircuit": "+ Nouveau circuit",
      "groupCta": "+ Superset"
    },
    "webview": {
      "close": "Fermer",
      "openExternal": "Ouvrir dans le navigateur",
      "errorTitle": "La page ne s'est pas chargée",
      "errorBody": "Touche ci-dessous pour essayer dans le navigateur système.",
      "fallbackErrorTitle": "Impossible d'ouvrir le navigateur",
      "fallbackErrorBody": "Réessaie depuis une autre connexion."
    },
    "plates": {
      "title": "Calculateur de disques",
      "close": "Fermer",
      "apply": "Appliquer",
      "targetLabel": "Cible",
      "barLabel": "Barre",
      "perSide": "Par côté : {{kg}} kg",
      "barOnly": "Barre seule — aucun disque.",
      "pairs_one": "{{count}} paire",
      "pairs_other": "{{count}} paires",
      "plates_one": "{{count}} disque",
      "plates_other": "{{count}} disques",
      "loadedEnd": "Extrémité chargée : {{kg}} kg",
      "landmineHint": "Landmine : seule l'extrémité libre est chargée. L'autre est ancrée au pivot.",
      "remainder": "Écart de {{kg}} kg — l'inventaire ne correspond pas exactement.",
      "belowBar": "Cible inférieure au poids de la barre.",
      "invalid": "Saisis un poids valide.",
      "inventoryShow": "Modifier l'inventaire des disques",
      "inventoryHide": "Masquer l'inventaire des disques",
      "inventoryTitle": "Paires disponibles",
      "pairsIncrement": "Ajouter une paire",
      "pairsDecrement": "Retirer une paire",
      "signLabel": "SIGNE EXTRA",
      "signAdd": "+ Lesté",
      "signAssist": "− Assisté"
    },
    "restTimerScreen": {
      "title": "Minuteurs",
      "back": "Retour"
    },
    "licenses": {
      "title": "Licences open source",
      "back": "Retour",
      "headlineIntro": "JackedLogs s'appuie sur un petit ensemble de bibliothèques qui façonnent vraiment l'app. Tape sur une ligne pour ouvrir le projet — et pense à soutenir celles que tu utilises le plus.",
      "coreSection": "Bibliothèques essentielles ({{count}})",
      "viewAllTitle": "Voir tous les paquets",
      "viewAllSub": "Attribution complète pour les {{count}} paquets embarqués dans l'APK, regroupés par projet.",
      "allTitle": "Tous les paquets ({{count}})",
      "searchAll": "Chercher nom, groupe, licence ou auteur",
      "groupOther": "Autres paquets",
      "empty": "Aucun paquet ne correspond à la recherche.",
      "footer": "Généré le {{date}}",
      "openErrorTitle": "Impossible d'ouvrir le lien"
    },
    "share": {
      "newPR": "NOUVEAU PR",
      "topLifts": "TOP EXERCICES",
      "durationMinute": "min",
      "durationHour": "h",
      "durationMinuteShort": "m",
      "footerSets": "séries",
      "footerDensitySuffix": "/min",
      "fallbackLabel": "Volume Total",
      "timeLabel": "Temps Total",
      "tutLabel": "TUT",
      "impulseUnit": "kg·s",
      "impulseLabel": "Impulsion",
      "e1rmSuffix": "E1RM"
    },
    "postSession": {
      "blockCalories": "Calories",
      "blockEffort": "Effort",
      "effortHr": "{{avg}} moy · {{peak}} pic bpm",
      "effortHrMax": "{{pct}}% FCmax",
      "shareTitle": "Séance JackedLogs",
      "shareErrorTitle": "Échec du partage",
      "headlineLabelPR": "NOUVEAU E1RM",
      "headlineLabelDelta": "GRAND BOND +{{delta}}",
      "headlineLabelSolid": "SÉANCE SOLIDE",
      "headlineSolidValue": "{{volume}} en {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} séries",
      "blockTopLifts": "Top exercices",
      "fromSet": "depuis {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Durée",
      "blockDensity": "Densité",
      "barsTitle": "Travail par muscle",
      "bodyTitle": "Muscles sollicités",
      "sharing": "Préparation…",
      "shareCta": "Partager la carte de séance",
      "done": "Terminé",
      "summaryTitle": "Séance enregistrée"
    },
    "common": {
      "back": "Retour",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "close": "Fermer"
    },
    "account": {
      "title": "Compte",
      "navSub": "Nom, mot de passe, export, suppression, déconnexion",
      "nameLabel": "NOM",
      "namePlaceholder": "Votre nom",
      "saved": "Enregistré",
      "passwordLabel": "CHANGER LE MOT DE PASSE",
      "currentPassword": "Mot de passe actuel",
      "newPassword": "Nouveau mot de passe",
      "confirmPassword": "Confirmer le nouveau mot de passe",
      "passwordChanged": "Mot de passe modifié.",
      "passwordSubmit": "Mettre à jour le mot de passe",
      "deleteNeedsConnection": "La suppression du compte nécessite une connexion. Reconnecte-toi et réessaie : cette demande n'est jamais mise en attente."
    },
    "prefs": {
      "title": "Unités et affichage",
      "navSub": "Unités, langue, infobulles",
      "unitsLabel": "Unités",
      "unitsHelp": "Unité de poids par défaut pour les nouvelles séries. Tu peux toujours la modifier par ligne dans le logger.",
      "weekStartLabel": "La semaine commence le",
      "weekStartHelp": "Le jour où ta semaine d'entraînement repart. Les objectifs hebdomadaires par muscle comptent à partir de ce jour.",
      "unitsKg": "Kilogrammes (kg)",
      "unitsLb": "Livres (lb)",
      "glucoseUnitsLabel": "Unités glycémie",
      "glucoseUnitsHelp": "Comment la glycémie est affichée et saisie. Stockée pareil dans les deux cas.",
      "glucoseMmol": "mmol/L",
      "glucoseMgdl": "mg/dL",
      "themePaletteLabel": "Palette du thème",
      "themePaletteHelp": "Choisissez la palette de couleurs utilisée dans toute l'application.",
      "themeModeLabel": "Apparence",
      "themeModeHelp": "Suivre le réglage du système, ou forcer clair ou sombre.",
      "themeMode": {
        "system": "Système",
        "light": "Clair",
        "dark": "Sombre"
      }
    },
    "timeline": {
      "setNumber": "Série {{n}}",
      "fail": "Échec",
      "failTip": "Échec enregistre la série comme tentée mais non terminée. Elle compte quand même comme faite (le minuteur de repos démarre), affiche ✕ dans la timeline et est exclue de votre e1RM.",
      "failTipA11y": "Que signifie Échec ?",
      "e1rmValue": "e1RM {{value}}",
      "e1rmPctOfBest": "{{pct}}% du record",
      "e1rmNewBest": "record",
      "e1rmLegend": "e1RM",
      "setVolume": "Σ {{value}} {{unit}}",
      "myorepTag": "Myo-rep",
      "dropsetTag": "Dégressif",
      "myorepA11y": "Série myo-reps",
      "dropsetA11y": "Série dégressive",
      "setVolumeA11y": "Volume de la série {{value}} {{unit}}",
      "setSummaryBothSidesA11y": "{{reps}} répétitions à {{weight}} {{unit}} par côté, les deux côtés comptés",
      "e1rmLegendA11y": "Qu'est-ce que l'e1RM ?",
      "e1rmTip": "L'e1RM est ton 1RM estimé pour la série (Epley, reps ≤ 12). « % du record » le compare à ton meilleur e1RM récent — plus bas = marge pour pousser ; ↑ record = nouveau record estimé.",
      "durationLabel": "Durée",
      "hourShort": "h",
      "minShort": "min",
      "secShort": "sec",
      "started": "Séance démarrée",
      "addSet": "Ajouter une série",
      "removeSet": "Retirer une série",
      "prevSet": "Série précédente",
      "nextSet": "Série suivante",
      "allLogged": "Toutes les séries enregistrées — touchez + pour en ajouter.",
      "rosterLabel": "Exercices",
      "rosterHint": "touchez pour changer",
      "focusEmptyHasRoster": "Sélectionne un exercice ci-dessus pour commencer, ou ajoutes-en un nouveau.",
      "focusAllLogged": "Toutes les séries enregistrées. Ajoute un exercice ci-dessus, ou enregistre ci-dessous.",
      "cueNextSet": "→ Série {{n}}/{{total}}",
      "cueNextExercise": "→ {{name}}",
      "rosterExpandA11y": "Déplier la liste des exercices",
      "rosterCollapseA11y": "Replier la liste des exercices",
      "rosterState": {
        "done": "terminé",
        "inProgress": "en cours",
        "notDone": "à commencer"
      },
      "rosterOccurrenceA11y": "{{label}} ({{index}} sur {{count}})",
      "exerciseNote": "Note d'exercice",
      "notePlaceholder": "Ajouter une note à la timeline…",
      "noteSend": "Envoyer la note",
      "noteExpandA11y": "Note — touchez pour lire en entier",
      "noteDeleteA11y": "Supprimer la note",
      "dropsetActive": "Dropset — modifie les séries ci-dessous.",
      "editingLogged": "Modification de la série {{n}} enregistrée — les changements sont sauvés avec la séance.",
      "addSetLocked": "Modification d'une séance passée : impossible d'ajouter des séries. Corrigez les valeurs ou supprimez une série.",
      "createGroupLocked": "Modification d'une séance passée : impossible de créer un superset.",
      "splitGroupLocked": "Modification d'une séance passée : impossible de dissoudre un superset.",
      "setTypeLocked": "Modification d'une séance passée : impossible de changer le type de série (dropset/myorep).",
      "addStepLocked": "Modification d'une séance passée : impossible d'ajouter une étape au dropset.",
      "setState": {
        "pending": "Série {{n}} sur {{total}}, à faire",
        "done": "Série {{n}} sur {{total}}, terminée",
        "pr": "Série {{n}} sur {{total}}, record personnel",
        "failed": "Série {{n}} sur {{total}}, ratée"
      },
      "holdLabel": "Maintien"
    },
    "home": {
      "targetsTopPatterns": "Schémas principaux",
      "targetsSummary": "{{on}} sur {{total}} dans la cible",
      "targetsHint": "Épingle un programme avec des objectifs hebdomadaires pour les évaluer.",
      "targetsZoneOnTarget": "dans la cible",
      "targetsZoneOver": "au-delà",
      "targetsZoneUnder": "en cours",
      "targetsNoCoverage": "hors programme",
      "targetsPrescribed": "prévu {{n}}",
      "targetsEmptyTitle": "Pas encore d'objectifs",
      "targetsEmptySub": "Définis combien tu veux entraîner chaque muscle par semaine. Ton programme y travaille ; le compteur de l'accueil te montre où tu en es.",
      "targetsEmptyCta": "Définir mes objectifs",
      "weekEyebrow": "Cette semaine",
      "weeklyTitle": "7 derniers jours",
      "weeklySessions": "Entraînements",
      "weeklyVolume": "Volume",
      "weeklyA11y": "{{sessions}} entraînements, {{volume}} de volume",
      "viewProgress": "Voir les progrès",
      "badgesTitle": "Badges",
      "newsTitle": "Actus",
      "newsEmpty": "Les nouveautés de l'app apparaîtront ici.",
      "prPrev": "Record précédent",
      "prNext": "Record suivant",
      "prPosition": "Record {{n}} sur {{total}}",
      "eyebrow": "AUJOURD'HUI",
      "blankTitle": "Prêt à t'entraîner ?",
      "blankLoading": "Chargement de ton plan…",
      "blankBody": "Aucun programme actif pour l'instant. Lance une séance vierge, ou utilise ＋ pour en planifier une.",
      "newWorkout": "Nouvelle séance",
      "programMeta": "{{program}} · Semaine {{week}}",
      "morePreview": " +{{count}} de plus",
      "startToday": "▶ Démarrer la séance",
      "blankInstead": "Lancer plutôt une séance vierge",
      "recentPrValue": "{{weight}} × {{reps}}",
      "recentPrValueBodyweight": "{{reps}} reps PdC",
      "prToday": "Aujourd'hui",
      "prDaysAgo": "il y a {{n}} j",
      "weightTitle": "Poids corporel",
      "weightSaved": "Enregistré ✓",
      "weightCurrent": "Dernier : {{value}} {{unit}}",
      "weightNone": "Enregistre ton poids pour suivre les tendances.",
      "weightSave": "Enregistrer",
      "repeatWorkout": "Répéter une séance",
      "form": {
        "title": "Forme",
        "ready": "Prêt",
        "caution": "Prudence",
        "rest": "Repos",
        "reasonNoData": "Enregistre une séance pour suivre ta forme.",
        "reasonWellRecovered": "Bien reposé depuis ta dernière séance — tu peux pousser.",
        "reasonBalanced": "Ta charge d'entraînement semble équilibrée.",
        "reasonFreshStart": "Tu reprends — vas-y doucement et construis une base.",
        "reasonShortRest": "Séances rapprochées — surveille ta récupération.",
        "reasonHighFrequency": "Semaine à fort volume — envisage une journée plus légère.",
        "reasonLoadSpike": "Ta charge a fortement augmenté par rapport à ta moyenne récente.",
        "reasonLongGap": "Ça fait un moment — reprends léger pour remonter en charge."
      },
      "glucoseSave": "Enregistrer",
      "weightSaveA11y": "Enregistrer le poids corporel",
      "glucoseSaveA11y": "Enregistrer la glycémie"
    },
    "superset": {
      "startingWith": "Démarrer le superset avec",
      "joinExisting": "Rejoindre un existant",
      "pairInWorkout": "Associer (dans cette séance)",
      "templates": "Supersets enregistrés",
      "templateInsertHint": "Insérer ce superset ; appui long pour supprimer",
      "templateDeleteBody": "Supprimer ce superset enregistré ?",
      "createCta": "Créer un superset ({{n}})",
      "cueCycle": "{{group}}, exercice {{pos}} sur {{total}}. Touchez pour passer à {{next}}.",
      "cueStatic": "{{group}}, exercice {{pos}} sur {{total}}",
      "menuOpen": "Options du superset",
      "menuSaveTemplate": "Enregistrer comme modèle",
      "menuAddExercise": "Ajouter un exercice",
      "menuMoveUp": "Monter",
      "menuMoveDown": "Descendre",
      "menuRemoveMember": "Retirer cet exercice",
      "menuSplit": "Dissoudre le superset",
      "namePlaceholder": "Nom du superset (facultatif)"
    }
  },
  "settings": {
    "restDefaults": {
      "title": "Défauts du minuteur de repos",
      "globalLabel": "Défaut global",
      "globalUnset": "Non défini — utilise {{n}}s",
      "customLabel": "Exercices avec un défaut personnalisé",
      "customEmpty": "Aucun remplacement par exercice. Ouvrez le bandeau de repos dans le Logger et touchez ⚙ pour en définir un.",
      "customRemoveA11y": "Supprimer le repos personnalisé pour {{name}}",
      "clearGlobal": "Réinitialiser"
    },
    "hints": {
      "title": "Astuces",
      "label": "Afficher les info-bulles",
      "help": "Touche l'en-tête d'une colonne pour savoir ce qu'elle signifie. Désactive pour masquer les info-bulles."
    },
    "effortNudge": {
      "label": "Rappel d'effort",
      "help": "Une pulsation rare et discrète sur la barre d'effort quand une série attend d'être enregistrée."
    },
    "inWorkoutMeter": {
      "label": "Compteur d'objectifs en séance",
      "help": "Un bandeau en haut de la carte d'exercice avec l'objectif hebdo des muscles que tu travailles."
    },
    "audio": {
      "title": "Audio",
      "soundLabel": "Son du minuteur",
      "soundHelp": "Joue lorsque le minuteur de repos se termine.",
      "vibrationLabel": "Vibration",
      "vibrationHelp": "Vibre lorsque le minuteur de repos se termine.",
      "previewButton": "Écouter",
      "pickerTitle": "Choisir un son",
      "pickerCancel": "Annuler",
      "category": {
        "serious": "Standard",
        "fun": "Amusants"
      },
      "soundOptions": {
        "none": "Aucun",
        "chime_crisp": "Carillon",
        "ding_dong": "Ding-dong",
        "meditation_bell": "Cloche de méditation",
        "tada_fanfare": "Ta-da",
        "cartoon_boing": "Boing",
        "ah_yeah": "Ouais !"
      }
    },
    "timerDefaults": {
      "range": "Entrez {{min}}–{{max}} s",
      "globalTitle": "Réglages globaux",
      "restGlobal": "Minuteur de repos",
      "holdGlobal": "Minuteur de maintien",
      "customLabel": "Réglages par exercice",
      "customEmpty": "Aucun réglage par exercice. Touchez + Ajouter.",
      "unset": "Non défini — {{n}} s",
      "add": "+ Ajouter",
      "editRestA11y": "Modifier le repos pour {{name}}",
      "editHoldA11y": "Modifier le maintien pour {{name}}",
      "editA11y": "Modifier les minuteurs de {{name}}",
      "isDefault": "défaut",
      "equalsDefaultHint": "Une valeur égale au réglage global n'est pas enregistrée comme réglage propre.",
      "remove": "Supprimer"
    },
    "backend": {
      "section": "Backend",
      "title": "Backend",
      "navSub": "Choisis où cette app écrit",
      "pickLabel": "Écrire mes données sur",
      "pickHelp": "Build dev uniquement. Chaque backend garde sa session, ses files d’attente et son brouillon de séance : changer ne touche jamais l’autre.",
      "stageProduction": "PRODUCTION",
      "stageLab": "LABORATOIRE",
      "liveLabel": "TU ÉCRIS SUR",
      "liveChecking": "Vérification…",
      "liveUnknown": "Inconnu — le backend n’a pas répondu",
      "liveNotProduction": "Ce n’est pas là que vit ton vrai entraînement.",
      "confirmTitle": "Changer de backend ?",
      "confirmBody": "L’app se recharge sur {{stage}}. Il faudra peut-être s’y connecter, et les listes en cache sont jetées.",
      "confirmCta": "Changer",
      "blockedByQueue": "Pas changé : des écritures ne sont pas encore parties. Reviens en ligne et laisse les files se vider."
    },
    "animations": {
      "cellularLabel": "Télécharger les animations sans Wi-Fi",
      "cellularHelp": "Désactivé par défaut. Les animations sont là de toute façon : ceci autorise seulement l'app à les récupérer à l'avance en données mobiles, entre 20 et 30 Mo pour un programme."
    }
  },
  "web": {
    "preauth": {
      "tagline": "De la musculation qui se planifie selon ton effort, ton état du moment et le matériel que tu as vraiment.",
      "status": "En développement. Inscriptions fermées.",
      "contactLabel": "Accès ou informations"
    },
    "crash": {
      "body": "L'application a rencontré une erreur inattendue. Tes données enregistrées sont en sécurité — recharge pour continuer.",
      "reload": "Recharger"
    },
    "postSession": {
      "headlineLabelPR": "NOUVEAU E1RM",
      "headlineLabelDelta": "GRAND BOND +{{delta}}",
      "headlineLabelSolid": "SÉANCE SOLIDE",
      "headlineSolidValue": "{{volume}} en {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} séries",
      "blockE1rm": "E1RM",
      "fromSet": "depuis {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Durée",
      "blockDensity": "Densité",
      "barsTitle": "Travail par muscle",
      "bodyTitle": "Muscles sollicités",
      "sharing": "Préparation…",
      "shareCta": "Partager la carte de séance"
    }
  },
  "muscle": {
    "quadriceps": "Quadriceps",
    "hamstrings": "Ischio-jambiers",
    "glutes": "Fessiers",
    "adductors": "Adducteurs",
    "abductors": "Abducteurs",
    "calves": "Mollets",
    "core": "Sangle abdominale",
    "obliques": "Obliques",
    "erectors": "Lombaires",
    "pectoralis": "Pectoraux",
    "anterior-delts": "Deltoïdes antérieurs",
    "lateral-delts": "Deltoïdes latéraux",
    "triceps": "Triceps",
    "lats": "Dorsaux",
    "rhomboids": "Rhomboïdes",
    "rear-delts": "Deltoïdes postérieurs",
    "traps": "Trapèzes",
    "biceps": "Biceps",
    "forearms": "Avant-bras"
  },
  "experience": {
    "menuLabel": "Profil actif",
    "athlete": "Athlète",
    "coach": "Coach",
    "admin": "Admin"
  },
  "composer": {
    "targetAxisExercise": "Exercice",
    "targetKeyExercise": "Exercice",
    "targetRefAvg": "~{{n}}/sem moy.",
    "targetRefLast": "dern. sem {{n}}",
    "targetRefNone": "Aucune donnée sur les 4 dernières semaines",
    "targetRefProgram": "le programme prescrit ~{{n}}/sem",
    "targetUseAvg": "Utiliser la moyenne",
    "targetUseProgram": "Utiliser le programme",
    "projectionTitle": "Répartition des objectifs",
    "projectionWeek": "Semaine {{n}}",
    "projectionContext": "Séries / charge prescrites par le programme en semaine {{n}}.",
    "projectionTarget": "Objectif",
    "projectionWeekTotal": "Sem.",
    "projectionRamp": "Cycle",
    "projectionWeekShort": "S{{n}}",
    "projectionEmpty": "Non prévu",
    "targetsTitle": "Objectifs hebdo",
    "targetsEmptyTitle": "Aucun objectif hebdo",
    "targetsEmptySub": "Ajoutez-en un pour activer la jauge de niveau.",
    "targetAdd": "Ajouter un objectif",
    "targetRemove": "Supprimer l'objectif {{name}}",
    "targetCollapse": "Réduire",
    "targetAxis": "Axe",
    "targetAxisMuscle": "Muscle",
    "targetMetric": "Métrique",
    "targetMetricHardSets": "Séries dures",
    "targetMetricTonnage": "Tonnage",
    "targetMetricReps": "Reps",
    "prescriptionEyebrow": "Prescription",
    "prescriptionSub": "Ce que ce bloc prescrit chaque semaine, comparé à vos objectifs.",
    "targetKeyMuscle": "Muscle",
    "targetValue": "Objectif hebdo",
    "targetUnitHardSets": "séries dures",
    "targetUnitTonnage": "kg",
    "targetUnitReps": "reps",
    "targetBand": "±{{pct}} %",
    "targetNotScored": "pas encore dans la jauge",
    "targetNotScoredNote": "Ce type d'objectif n'est pas encore pris en compte par la jauge de niveau.",
    "targetBandLabel": "Tolérance",
    "targetBandAsym": "−{{lo}} % / +{{hi}} %",
    "targetBandBelow": "Pourcentage sous l'objectif",
    "targetBandAbove": "Pourcentage au-dessus de l'objectif",
    "targetBandRange": "En dessous 0–99 %, au-dessus 0 % ou plus.",
    "compose": "Composer",
    "preview": "Aperçu",
    "addExercises": "Ajouter des exercices",
    "editingBlockDay": "Modification de J{{d}} — Mettre à jour s'applique à ce jour (cochez d'autres jours pour l'y appliquer aussi)",
    "editingRampDay": "Progression hebdo sur J{{d}} — la mise à jour s'applique aux semaines sélectionnées, ce jour uniquement",
    "segments": "Segments",
    "rampSwitchHint": "Mettez à jour ou annulez avant de changer de segment",
    "setupHint": "Définissez la forme de départ — vous pourrez ajouter ou retirer des jours et changer les semaines plus tard, dans l'éditeur.",
    "repsHint": "Reps « 5+ » = AMRAP : au moins 5, puis autant que possible.",
    "repsHintA11y": "Comment s'écrivent les répétitions",
    "addingWeek": "Nouvelle semaine W{{n}} — Mettre à jour l'ajoute à cet exercice",
    "cloneWeek": "Cloner la semaine…",
    "cloneWeekFrom": "De",
    "cloneWeekApply": "Cloner",
    "cloneWeekConflict": "{{name}} a déjà du contenu en W{{week}} (D{{day}})",
    "cloneWeekEmpty": "Rien à cloner — choisissez une semaine source remplie et au moins une cible",
    "cloneDayEmpty": "Rien à cloner pour ce jour",
    "editingWeekDay": "Modification de W{{n}} sur J{{d}} uniquement — Mettre à jour la détache du segment",
    "perWeek": "Par semaine",
    "dupExercise": "{{name}} est déjà présent en D{{day}} dans les semaines sélectionnées",
    "cloneDay": "Cloner D{{n}} vers…",
    "cloneDayTarget": "Vers",
    "days": "Jours",
    "weeks": "Semaines",
    "setNote": "Note de la série",
    "removeExercise": "Retirer l'exercice",
    "replaceExercise": "Remplacer l'exercice",
    "clone": "Cloner",
    "remove": "Retirer",
    "removeConfirm": "Confirmer ? ({{n}} cellules)",
    "verbatim": "Slot avancé (multi-variante) — conservé tel quel, non modifiable ici",
    "metaWeeks": "{{n}} semaines",
    "metaDays": "{{n}} jours d'entraînement",
    "gridToggle": "Grille d'intensité",
    "addDay": "Ajouter un jour",
    "removeDay": "Supprimer le jour D{{n}}",
    "removeDayConfirm": "Confirmer — supprimer le jour D{{n}} ?",
    "dayEmpty": "Aucun exercice ce jour. Ajoutez-en un pour le composer.",
    "prescribeDayEmpty": "Aucun exercice ce jour.",
    "prescribeFocusEmpty": "Touchez un exercice ci-dessus pour en prescrire les séries.",
    "prescribeViewMatrix": "Matrice",
    "prescribeViewEditor": "Éditeur",
    "prescribeViewGroup": "Changer de vue",
    "checkEmptyCell": "W{{w}}·D{{d}} n'a aucun exercice",
    "checkPctNoMax": "{{name}} utilise %MAX sans MAX enregistré",
    "exerciseNote": "Note pour l'exercice",
    "exerciseNotePlaceholder": "Note pour cet exercice (visible pendant le log)",
    "panelHint": "Touchez un exercice pour modifier, cloner ou retirer",
    "warnLine_one": "{{count}} avertissement",
    "warnLine_other": "{{count}} avertissements",
    "adjacencyWarnLine_one": "{{count}} avertissement de récupération musculaire",
    "adjacencyWarnLine_other": "{{count}} avertissements de récupération musculaire",
    "adjacencyWarnItem": "{{muscle}} entraîné sur des jours adjacents ({{count}}×)",
    "publishChecklist": "Avertissements ouverts (publier quand même est possible)",
    "publishClean": "Aucun avertissement.",
    "weekShort": "Semaine",
    "placed": "actif",
    "notPlaced": "inactif",
    "placementHint": "Maintenez une case appuyée pour y placer ou en retirer {{exercise}}.",
    "addWeek": "Ajouter une semaine",
    "removeWeek": "Supprimer la semaine",
    "holdToRemoveHint": "Maintenez appuyé un jour ou une semaine pour supprimer",
    "holdDayToRemoveHint": "Maintenez un jour appuyé pour le supprimer",
    "holdWeekToRemoveHint": "Maintenez une semaine appuyée pour la supprimer",
    "removeWeekConfirm": "Confirmer — supprimer cette semaine et ses séries",
    "coverageTitle": "Couverture — séries dures/semaine",
    "coverageHint": "Moyenne sur tout le cycle. Un zéro apparaît ici avant même de l'avoir entraîné.",
    "rosterNotThisWeek": "pas dans cette semaine",
    "dayWeekCursor": "D{{d}}·W{{w}}",
    "prescribeNotThisWeek": "{{exercise}} n'est pas prévu sur {{cursor}}.",
    "prescribePlaceHere": "Placer sur {{cursor}}",
    "placementAddHere": "Placer {{exercise}} ici",
    "placementRemoveHere": "Retirer {{exercise}} d'ici",
    "weekCue": "Semaine {{pos}} sur {{total}}. Touchez pour la semaine suivante.",
    "weekCuePrev": "Semaine précédente"
  },
  "gym": {
    "setPlace": "Où ?",
    "whichPlace": "Où t'entraînes-tu ?",
    "newPlace": "Ajouter un endroit",
    "fallback": "Par défaut",
    "chipA11y": "Lieu d'entraînement",
    "footnote": "Trie ce que tu vois en premier. Jamais transmis à un coach.",
    "namePlaceTitle": "Nomme cet endroit",
    "namePlaceHint": "Nom de l'endroit",
    "namePlaceSave": "Utiliser cet endroit",
    "pinPlace": "Définir {{place}} comme lieu par défaut",
    "unpinPlace": "Retirer {{place}} comme lieu par défaut",
    "pinHint": "Retient ce lieu comme celui où tu t'entraînes d'habitude.",
    "unpinHint": "Oublie ton lieu par défaut.",
    "pinErrorTitle": "Non enregistré",
    "pinErrorBody": "Ton lieu par défaut est inchangé."
  }
}
